var map = {
	"./assets/calculator-slider-styles.css": 920,
	"./assets/colors.scss": 2347,
	"./assets/default.scss": 461,
	"./assets/fonts/MDI/materialdesignicons-webfont.eot": 2349,
	"./assets/fonts/MDI/materialdesignicons-webfont.ttf": 2350,
	"./assets/fonts/MDI/materialdesignicons-webfont.woff": 2351,
	"./assets/fonts/MDI/materialdesignicons-webfont.woff2": 2352,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-Black.eot": 2353,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-BlackItalic.eot": 2354,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-Bold.eot": 274,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-BoldItalic.eot": 2355,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-Condensed.eot": 2356,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-CondensedBlack.eot": 2357,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-CondensedBlackItalic.eot": 2358,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-CondensedBold.eot": 2359,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-CondensedBoldItalic.eot": 2360,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-CondensedExtraBold.eot": 2361,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-CondensedExtraBoldItalic.eot": 2362,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-CondensedExtraLight.eot": 2363,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-CondensedExtraLightItalic.eot": 2364,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-CondensedHeavy.eot": 2365,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-CondensedHeavyItalic.eot": 2366,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-CondensedItalic.eot": 2367,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-CondensedLight.eot": 2368,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-CondensedLightItalic.eot": 2369,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-CondensedMedium.eot": 2370,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-CondensedMediumItalic.eot": 2371,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-CondensedSemiBold.eot": 2372,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-CondensedSemiBoldItalic.eot": 2373,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-CondensedSuperHeavy.eot": 2374,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-CondensedSuperHeavyItalic.eot": 2375,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-CondensedThin.eot": 2376,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-CondensedThinItalic.eot": 2377,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-CondensedUltraBold.eot": 2378,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-CondensedUltraBoldItalic.eot": 2379,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-ExtraBold.eot": 2380,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-ExtraBoldItalic.eot": 2381,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-ExtraLight.eot": 259,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-ExtraLightItalic.eot": 2382,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-Heavy.eot": 2383,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-HeavyItalic.eot": 2384,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-Italic.eot": 2385,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-Light.eot": 262,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-LightItalic.eot": 2386,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-Medium.eot": 265,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-MediumItalic.eot": 2387,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-Regular.eot": 277,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-SemiBold.eot": 268,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-SemiBoldItalic.eot": 2388,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-SuperHeavy.eot": 2389,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-SuperHeavyItalic.eot": 2390,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-Thin.eot": 256,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-ThinItalic.eot": 2391,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-UltraBold.eot": 271,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-UltraBoldItalic.eot": 2392,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-Black.woff": 2393,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-BlackItalic.woff": 2394,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-Bold.woff": 276,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-BoldItalic.woff": 2395,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-Condensed.woff": 2396,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-CondensedBlack.woff": 2397,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-CondensedBlackItalic.woff": 2398,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-CondensedBold.woff": 2399,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-CondensedBoldItalic.woff": 2400,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-CondensedExtraBold.woff": 2401,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-CondensedExtraBoldItalic.woff": 2402,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-CondensedExtraLight.woff": 2403,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-CondensedExtraLightItalic.woff": 2404,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-CondensedHeavy.woff": 2405,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-CondensedHeavyItalic.woff": 2406,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-CondensedItalic.woff": 2407,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-CondensedLight.woff": 2408,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-CondensedLightItalic.woff": 2409,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-CondensedMedium.woff": 2410,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-CondensedMediumItalic.woff": 2411,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-CondensedSemiBold.woff": 2412,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-CondensedSemiBoldItalic.woff": 2413,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-CondensedSuperHeavy.woff": 2414,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-CondensedSuperHeavyItalic.woff": 2415,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-CondensedThin.woff": 2416,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-CondensedThinItalic.woff": 2417,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-CondensedUltraBold.woff": 2418,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-CondensedUltraBoldItalic.woff": 2419,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-ExtraBold.woff": 2420,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-ExtraBoldItalic.woff": 2421,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-ExtraLight.woff": 261,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-ExtraLightItalic.woff": 2422,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-Heavy.woff": 2423,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-HeavyItalic.woff": 2424,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-Italic.woff": 2425,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-Light.woff": 264,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-LightItalic.woff": 2426,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-Medium.woff": 267,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-MediumItalic.woff": 2427,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-Regular.woff": 279,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-SemiBold.woff": 270,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-SemiBoldItalic.woff": 2428,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-SuperHeavy.woff": 2429,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-SuperHeavyItalic.woff": 2430,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-Thin.woff": 258,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-ThinItalic.woff": 2431,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-UltraBold.woff": 273,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-UltraBoldItalic.woff": 2432,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-Black.woff2": 2433,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-BlackItalic.woff2": 2434,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-Bold.woff2": 275,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-BoldItalic.woff2": 2435,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-Condensed.woff2": 2436,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-CondensedBlack.woff2": 2437,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-CondensedBlackItalic.woff2": 2438,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-CondensedBold.woff2": 2439,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-CondensedBoldItalic.woff2": 2440,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-CondensedExtraBold.woff2": 2441,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-CondensedExtraBoldItalic.woff2": 2442,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-CondensedExtraLight.woff2": 2443,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-CondensedExtraLightItalic.woff2": 2444,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-CondensedHeavy.woff2": 2445,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-CondensedHeavyItalic.woff2": 2446,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-CondensedItalic.woff2": 2447,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-CondensedLight.woff2": 2448,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-CondensedLightItalic.woff2": 2449,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-CondensedMedium.woff2": 2450,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-CondensedMediumItalic.woff2": 2451,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-CondensedSemiBold.woff2": 2452,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-CondensedSemiBoldItalic.woff2": 2453,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-CondensedSuperHeavy.woff2": 2454,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-CondensedSuperHeavyItalic.woff2": 2455,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-CondensedThin.woff2": 2456,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-CondensedThinItalic.woff2": 2457,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-CondensedUltraBold.woff2": 2458,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-CondensedUltraBoldItalic.woff2": 2459,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-ExtraBold.woff2": 2460,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-ExtraBoldItalic.woff2": 2461,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-ExtraLight.woff2": 260,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-ExtraLightItalic.woff2": 2462,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-Heavy.woff2": 2463,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-HeavyItalic.woff2": 2464,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-Italic.woff2": 2465,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-Light.woff2": 263,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-LightItalic.woff2": 2466,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-Medium.woff2": 266,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-MediumItalic.woff2": 2467,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-Regular.woff2": 278,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-SemiBold.woff2": 269,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-SemiBoldItalic.woff2": 2468,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-SuperHeavy.woff2": 2469,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-SuperHeavyItalic.woff2": 2470,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-Thin.woff2": 257,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-ThinItalic.woff2": 2471,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-UltraBold.woff2": 272,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-UltraBoldItalic.woff2": 2472,
	"./assets/fonts/fonts.css": 462,
	"./assets/images/404-image.svg": 399,
	"./assets/images/404.png": 1934,
	"./assets/images/404.svg": 1935,
	"./assets/images/504.png": 400,
	"./assets/images/AboutUs/10.png": 1289,
	"./assets/images/AboutUs/AboutUs.png": 1693,
	"./assets/images/AboutUs/CDN.svg": 1694,
	"./assets/images/AboutUs/Colocation.svg": 1695,
	"./assets/images/AboutUs/about-header.svg": 1696,
	"./assets/images/AboutUs/analytics.svg": 1697,
	"./assets/images/AboutUs/budget.svg": 1698,
	"./assets/images/AboutUs/consulting.svg": 1699,
	"./assets/images/AboutUs/container.svg": 1700,
	"./assets/images/AboutUs/contract.svg": 1701,
	"./assets/images/AboutUs/cost.svg": 1702,
	"./assets/images/AboutUs/demo.svg": 1703,
	"./assets/images/AboutUs/header.svg": 1704,
	"./assets/images/AboutUs/history.png": 1705,
	"./assets/images/AboutUs/license.svg": 1706,
	"./assets/images/AboutUs/mission.png": 1707,
	"./assets/images/AboutUs/missionicon.png": 1708,
	"./assets/images/AboutUs/pop.svg": 1709,
	"./assets/images/AboutUs/sazman.svg": 1710,
	"./assets/images/AboutUs/security.svg": 1711,
	"./assets/images/AboutUs/uptime.svg": 1712,
	"./assets/images/ContactUs/1.png": 1726,
	"./assets/images/ContactUs/2.png": 1727,
	"./assets/images/ContactUs/3.png": 1728,
	"./assets/images/ContactUs/4.png": 1729,
	"./assets/images/ContactUs/5.png": 1730,
	"./assets/images/ContactUs/Blog.svg": 1731,
	"./assets/images/ContactUs/Blog.webp": 1732,
	"./assets/images/ContactUs/ContactUs.png": 1733,
	"./assets/images/ContactUs/ContactUsicon.png": 1734,
	"./assets/images/ContactUs/Help.webp": 1735,
	"./assets/images/ContactUs/Location.svg": 1736,
	"./assets/images/ContactUs/Question.svg": 1737,
	"./assets/images/ContactUs/Search.webp": 1738,
	"./assets/images/ContactUs/Video.svg": 1739,
	"./assets/images/ContactUs/facebook.svg": 1740,
	"./assets/images/ContactUs/header.svg": 1574,
	"./assets/images/ContactUs/instagram.svg": 1741,
	"./assets/images/ContactUs/linkedin.svg": 1742,
	"./assets/images/ContactUs/mail.svg": 1575,
	"./assets/images/ContactUs/map-m.svg": 1743,
	"./assets/images/ContactUs/map.svg": 1744,
	"./assets/images/ContactUs/person.svg": 1576,
	"./assets/images/ContactUs/phone.svg": 1430,
	"./assets/images/ContactUs/pointer.svg": 1577,
	"./assets/images/ContactUs/support.svg": 1578,
	"./assets/images/ContactUs/telegram.svg": 1745,
	"./assets/images/ContactUs/ticket.svg": 1579,
	"./assets/images/ContactUs/twitter.svg": 1746,
	"./assets/images/ContactUs/youtube.svg": 1747,
	"./assets/images/MainSlider-ld/1.png": 1936,
	"./assets/images/MainSlider-ld/2.png": 1937,
	"./assets/images/MainSlider-ld/3.png": 1938,
	"./assets/images/MainSlider-ld/4.png": 1939,
	"./assets/images/MainSlider-ld/Main.png": 1940,
	"./assets/images/MainSlider/1.png": 1941,
	"./assets/images/MainSlider/2.png": 1942,
	"./assets/images/MainSlider/3.png": 1943,
	"./assets/images/MainSlider/4.png": 1944,
	"./assets/images/MainSlider/Cloud-migration.jpg": 1945,
	"./assets/images/MainSlider/Cloud-migration.webp": 1748,
	"./assets/images/MainSlider/Main.png": 1946,
	"./assets/images/MainSlider/Slider.png": 1947,
	"./assets/images/MainSlider/XaaSSliderPlaformKubernetes.svg": 1948,
	"./assets/images/MainSlider/XaaSSliderPlaformKubernetes1.svg": 1949,
	"./assets/images/MainSlider/x-background.svg": 1950,
	"./assets/images/MainSlider/xaas-logo.svg": 1951,
	"./assets/images/ManagedService/Adobe.svg": 1162,
	"./assets/images/ManagedService/Atlassia.svg": 1163,
	"./assets/images/ManagedService/Big.svg": 1164,
	"./assets/images/ManagedService/Bugzilla.svg": 1165,
	"./assets/images/ManagedService/Cpanel.svg": 1166,
	"./assets/images/ManagedService/Customers/Etebar-gary.png": 1094,
	"./assets/images/ManagedService/Customers/Etebar.png": 1095,
	"./assets/images/ManagedService/Customers/Mapna-gray.png": 1096,
	"./assets/images/ManagedService/Customers/Sina- gray.png": 1097,
	"./assets/images/ManagedService/Customers/Sina.png": 1098,
	"./assets/images/ManagedService/Customers/afam-color.png": 1099,
	"./assets/images/ManagedService/Customers/afam-gray.png": 1100,
	"./assets/images/ManagedService/Customers/banner-eseminar.webp": 1101,
	"./assets/images/ManagedService/Customers/banner-helal.webp": 1102,
	"./assets/images/ManagedService/Customers/banner-kale.webp": 1103,
	"./assets/images/ManagedService/Customers/banner-mapna.webp": 1104,
	"./assets/images/ManagedService/Customers/bime.webp": 1105,
	"./assets/images/ManagedService/Customers/eseminar-d.webp": 1106,
	"./assets/images/ManagedService/Customers/eseminar.webp": 1107,
	"./assets/images/ManagedService/Customers/helal-d.webp": 1108,
	"./assets/images/ManagedService/Customers/helal.webp": 1109,
	"./assets/images/ManagedService/Customers/industry.webp": 1110,
	"./assets/images/ManagedService/Customers/it.webp": 1111,
	"./assets/images/ManagedService/Customers/kale-d.webp": 1112,
	"./assets/images/ManagedService/Customers/kale.webp": 1113,
	"./assets/images/ManagedService/Customers/mapna-color.png": 1114,
	"./assets/images/ManagedService/Customers/mapna-d.webp": 1115,
	"./assets/images/ManagedService/Customers/mapna.webp": 1116,
	"./assets/images/ManagedService/Customers/software.webp": 1117,
	"./assets/images/ManagedService/Direct.svg": 1167,
	"./assets/images/ManagedService/Django.svg": 1168,
	"./assets/images/ManagedService/Elsstic.svg": 1169,
	"./assets/images/ManagedService/Jira.svg": 1170,
	"./assets/images/ManagedService/MariaDB.svg": 1171,
	"./assets/images/ManagedService/Maskgroup.svg": 1133,
	"./assets/images/ManagedService/Microsoft.svg": 1172,
	"./assets/images/ManagedService/MongoDB.svg": 1173,
	"./assets/images/ManagedService/Moodle.svg": 1174,
	"./assets/images/ManagedService/MySQL.svg": 1175,
	"./assets/images/ManagedService/Neo4j.svg": 1176,
	"./assets/images/ManagedService/Opencart.svg": 1177,
	"./assets/images/ManagedService/Plone.svg": 1178,
	"./assets/images/ManagedService/PostgreSQL.svg": 1179,
	"./assets/images/ManagedService/R1.svg": 914,
	"./assets/images/ManagedService/R2.svg": 915,
	"./assets/images/ManagedService/R3.svg": 916,
	"./assets/images/ManagedService/R4.svg": 917,
	"./assets/images/ManagedService/REDMINE.svg": 1180,
	"./assets/images/ManagedService/Rocket.svg": 1181,
	"./assets/images/ManagedService/Step1-m.svg": 1182,
	"./assets/images/ManagedService/Step1.svg": 1183,
	"./assets/images/ManagedService/Step2-m.svg": 1184,
	"./assets/images/ManagedService/Step2.svg": 1185,
	"./assets/images/ManagedService/Step3.svg": 1186,
	"./assets/images/ManagedService/Wordmark.svg": 1187,
	"./assets/images/ManagedService/agility.svg": 1188,
	"./assets/images/ManagedService/avatar.svg": 1189,
	"./assets/images/ManagedService/avatar2.svg": 1190,
	"./assets/images/ManagedService/avatar3.svg": 1191,
	"./assets/images/ManagedService/avatar4.svg": 1192,
	"./assets/images/ManagedService/avatar5.svg": 1193,
	"./assets/images/ManagedService/cancle.svg": 1194,
	"./assets/images/ManagedService/centralized.svg": 1195,
	"./assets/images/ManagedService/configuration.svg": 1196,
	"./assets/images/ManagedService/devops.svg": 1197,
	"./assets/images/ManagedService/enterprise.svg": 1198,
	"./assets/images/ManagedService/exclusive.svg": 1199,
	"./assets/images/ManagedService/focus.svg": 1200,
	"./assets/images/ManagedService/hardening.svg": 1201,
	"./assets/images/ManagedService/header.svg": 880,
	"./assets/images/ManagedService/hero.svg": 1147,
	"./assets/images/ManagedService/iRedMail.svg": 1202,
	"./assets/images/ManagedService/joomla.svg": 1203,
	"./assets/images/ManagedService/laravel.svg": 1204,
	"./assets/images/ManagedService/managed_service.png": 1205,
	"./assets/images/ManagedService/managedservices_catalogue.png": 1206,
	"./assets/images/ManagedService/monitor.svg": 1207,
	"./assets/images/ManagedService/monitoring.svg": 1208,
	"./assets/images/ManagedService/osCommerce.svg": 1209,
	"./assets/images/ManagedService/prometheus.svg": 1210,
	"./assets/images/ManagedService/redis.svg": 1211,
	"./assets/images/ManagedService/section-header.svg": 959,
	"./assets/images/ManagedService/technical.svg": 1212,
	"./assets/images/ManagedService/tick.svg": 918,
	"./assets/images/ManagedService/tick1.svg": 1213,
	"./assets/images/ManagedService/woocommerce.svg": 1214,
	"./assets/images/Pack1/Back.png": 1952,
	"./assets/images/Pack1/Back1.svg": 1953,
	"./assets/images/Pack1/CloudServer.png": 1954,
	"./assets/images/Pack1/CloudServer.svg": 1955,
	"./assets/images/Pack1/Server1.svg": 1956,
	"./assets/images/Pack1/Server2.svg": 1957,
	"./assets/images/Pack1/Server3.svg": 1958,
	"./assets/images/Pack1/server1.png": 1959,
	"./assets/images/Pack1/server2.png": 1960,
	"./assets/images/Pack1/server3.png": 1961,
	"./assets/images/Pack1/svg/Back1.svg": 1962,
	"./assets/images/Pack1/svg/CloudServer.svg": 1963,
	"./assets/images/Pack1/svg/Server1.svg": 1964,
	"./assets/images/Pack1/svg/Server2.svg": 1965,
	"./assets/images/Pack1/svg/Server3.svg": 1966,
	"./assets/images/Pack2/Back1.svg": 1967,
	"./assets/images/Pack2/Back2.png": 1968,
	"./assets/images/Pack2/Security1.svg": 1969,
	"./assets/images/Pack2/Security2.svg": 1970,
	"./assets/images/Pack2/security1.png": 1971,
	"./assets/images/Pack2/security2.png": 1972,
	"./assets/images/Pack2/svg/Back1.svg": 1973,
	"./assets/images/Pack2/svg/Security1.svg": 1974,
	"./assets/images/Pack2/svg/Security2.svg": 1975,
	"./assets/images/Pack3/Back1.svg": 1976,
	"./assets/images/Pack3/Back2.png": 1977,
	"./assets/images/Pack3/Support.png": 1978,
	"./assets/images/Pack3/Support.svg": 1979,
	"./assets/images/Pack3/svg/Back1.svg": 1980,
	"./assets/images/Pack3/svg/Support.svg": 1981,
	"./assets/images/Pack4/P1.png": 1982,
	"./assets/images/Pack4/P1.svg": 1983,
	"./assets/images/Pack4/P12.png": 1984,
	"./assets/images/Pack4/P2.png": 1985,
	"./assets/images/Pack4/P2.svg": 1986,
	"./assets/images/Pack4/P22.png": 1987,
	"./assets/images/Pack4/P3.png": 1988,
	"./assets/images/Pack4/P3.svg": 1989,
	"./assets/images/Pack5/managed.png": 1990,
	"./assets/images/Pack5/private.png": 1991,
	"./assets/images/Pack5/server.png": 1992,
	"./assets/images/Pack5/svg/managed.svg": 1993,
	"./assets/images/Pack5/svg/private.svg": 1994,
	"./assets/images/Pack5/svg/vpc.svg": 1995,
	"./assets/images/Pack5/svg/vps.svg": 1996,
	"./assets/images/Pack5/vpc.png": 1997,
	"./assets/images/Slider/Back.png": 1998,
	"./assets/images/Slider/Back.svg": 1999,
	"./assets/images/Slider/CloudMain.png": 2000,
	"./assets/images/Slider/CloudMain.svg": 2001,
	"./assets/images/Slider/Group368.png": 2002,
	"./assets/images/Slider/Group368.svg": 2003,
	"./assets/images/Slider/Group383.svg": 2004,
	"./assets/images/Slider/Part1.png": 2005,
	"./assets/images/Slider/Part1.svg": 2006,
	"./assets/images/Slider/Part2.png": 2007,
	"./assets/images/Slider/Part2.svg": 2008,
	"./assets/images/Slider/VPC.png": 2009,
	"./assets/images/Slider/VPC.svg": 2010,
	"./assets/images/Slider/cloud.png": 2011,
	"./assets/images/Slider/cloud.svg": 2012,
	"./assets/images/Slider/managed.png": 2013,
	"./assets/images/Slider/managed.svg": 2014,
	"./assets/images/Technicals/1.png": 2015,
	"./assets/images/Technicals/11.png": 2016,
	"./assets/images/Technicals/12.png": 2017,
	"./assets/images/Technicals/2.png": 2018,
	"./assets/images/Technicals/3.png": 2019,
	"./assets/images/Technicals/4.png": 2020,
	"./assets/images/Technicals/5.png": 2021,
	"./assets/images/Technicals/6.png": 2022,
	"./assets/images/Technicals/7.png": 2023,
	"./assets/images/Technicals/8.png": 2024,
	"./assets/images/Technicals/9.png": 2025,
	"./assets/images/Technicals/Technicals10.png": 2026,
	"./assets/images/VPC/1.png": 1017,
	"./assets/images/VPC/10.png": 1018,
	"./assets/images/VPC/11.png": 1019,
	"./assets/images/VPC/2.png": 1020,
	"./assets/images/VPC/3.png": 1021,
	"./assets/images/VPC/4.png": 1022,
	"./assets/images/VPC/5.png": 1023,
	"./assets/images/VPC/6.png": 1024,
	"./assets/images/VPC/7.png": 1025,
	"./assets/images/VPC/Api.svg": 1026,
	"./assets/images/VPC/CloudCanvas.svg": 1027,
	"./assets/images/VPC/Customers/VPC-IT.jpg": 948,
	"./assets/images/VPC/Customers/VPC-banks.jpg": 949,
	"./assets/images/VPC/Customers/VPC-innovation.jpg": 950,
	"./assets/images/VPC/Customers/VPC-insurance.jpg": 951,
	"./assets/images/VPC/Firewall.svg": 1028,
	"./assets/images/VPC/LoadBalancers.svg": 1029,
	"./assets/images/VPC/NetworkTopology.svg": 1030,
	"./assets/images/VPC/Step1-m.svg": 1031,
	"./assets/images/VPC/Step1.svg": 1032,
	"./assets/images/VPC/Step2-m.svg": 1011,
	"./assets/images/VPC/Step2.svg": 1012,
	"./assets/images/VPC/Step3.svg": 1013,
	"./assets/images/VPC/VPC-Main.svg": 1033,
	"./assets/images/VPC/VPC_Info.svg": 1034,
	"./assets/images/VPC/VS.svg": 876,
	"./assets/images/VPC/VirtualMachins.svg": 1035,
	"./assets/images/VPC/Volumes.svg": 1036,
	"./assets/images/VPC/backup.svg": 1037,
	"./assets/images/VPC/blancing.svg": 1038,
	"./assets/images/VPC/cancle.svg": 877,
	"./assets/images/VPC/cloud-security.svg": 1039,
	"./assets/images/VPC/cloudstorage.svg": 881,
	"./assets/images/VPC/cover-video.jpg": 1040,
	"./assets/images/VPC/dashboard.svg": 1041,
	"./assets/images/VPC/datacenter.svg": 882,
	"./assets/images/VPC/firewall.png": 1042,
	"./assets/images/VPC/freeSupport.svg": 1043,
	"./assets/images/VPC/header.svg": 913,
	"./assets/images/VPC/hq.svg": 1044,
	"./assets/images/VPC/image.svg": 1045,
	"./assets/images/VPC/improve.svg": 1046,
	"./assets/images/VPC/infrustructure.svg": 1047,
	"./assets/images/VPC/ip.png": 1048,
	"./assets/images/VPC/network.png": 1049,
	"./assets/images/VPC/openstack.svg": 1050,
	"./assets/images/VPC/platform.png": 1051,
	"./assets/images/VPC/sazman.svg": 1052,
	"./assets/images/VPC/sdn.svg": 1053,
	"./assets/images/VPC/section-header.svg": 1054,
	"./assets/images/VPC/security.svg": 1055,
	"./assets/images/VPC/service-mgs.svg": 1056,
	"./assets/images/VPC/signup.svg": 1057,
	"./assets/images/VPC/sla.svg": 1058,
	"./assets/images/VPC/snapshot.svg": 1059,
	"./assets/images/VPC/store.svg": 1060,
	"./assets/images/VPC/support.svg": 1061,
	"./assets/images/VPC/tick.svg": 878,
	"./assets/images/VPC/video.png": 1062,
	"./assets/images/VPC/vpc-patform.png": 1063,
	"./assets/images/VPC/vpc1.png": 1064,
	"./assets/images/VPC/vpc10.png": 1065,
	"./assets/images/VPC/vpc100.png": 1066,
	"./assets/images/VPC/vpc11.png": 1067,
	"./assets/images/VPC/vpc12.png": 1068,
	"./assets/images/VPC/vpc13.png": 1069,
	"./assets/images/VPC/vpc15.png": 1070,
	"./assets/images/VPC/vpc17.png": 1071,
	"./assets/images/VPC/vpc18.png": 1072,
	"./assets/images/VPC/vpc19.png": 1073,
	"./assets/images/VPC/vpc2.png": 1074,
	"./assets/images/VPC/vpc3.png": 1075,
	"./assets/images/VPC/vpc4.png": 1076,
	"./assets/images/VPC/vpc5.png": 1077,
	"./assets/images/VPC/vpc_platform.png": 1078,
	"./assets/images/VPS/1minute.svg": 761,
	"./assets/images/VPS/24.svg": 762,
	"./assets/images/VPS/AlmaLinux.svg": 763,
	"./assets/images/VPS/Customers/VPS-foods.jpg": 753,
	"./assets/images/VPS/Customers/VPS-khandevane.jpg": 754,
	"./assets/images/VPS/Customers/VPS-manufacturing-firms.jpg": 755,
	"./assets/images/VPS/Customers/VPS-sunich.jpg": 756,
	"./assets/images/VPS/Feature-3.svg": 764,
	"./assets/images/VPS/Feature-4.svg": 765,
	"./assets/images/VPS/Feature-5.svg": 766,
	"./assets/images/VPS/Feature-8.svg": 767,
	"./assets/images/VPS/Fedora.svg": 768,
	"./assets/images/VPS/Google.svg": 769,
	"./assets/images/VPS/HA.svg": 770,
	"./assets/images/VPS/Isolation.svg": 771,
	"./assets/images/VPS/P1.png": 772,
	"./assets/images/VPS/P2.png": 773,
	"./assets/images/VPS/P3.png": 774,
	"./assets/images/VPS/P4.png": 775,
	"./assets/images/VPS/P5.png": 776,
	"./assets/images/VPS/PfSense.svg": 777,
	"./assets/images/VPS/Rocky_Linux.svg": 778,
	"./assets/images/VPS/Step1-m.svg": 779,
	"./assets/images/VPS/Step1.svg": 780,
	"./assets/images/VPS/Step2-m.svg": 781,
	"./assets/images/VPS/Step2.svg": 782,
	"./assets/images/VPS/Step3.svg": 783,
	"./assets/images/VPS/Successful-Google-Cloud-Migration-1440x564_c 1.svg": 784,
	"./assets/images/VPS/VPS_Info_.svg": 785,
	"./assets/images/VPS/ads1.svg": 786,
	"./assets/images/VPS/ads2.svg": 787,
	"./assets/images/VPS/apache.svg": 788,
	"./assets/images/VPS/architect.svg": 789,
	"./assets/images/VPS/backup.svg": 790,
	"./assets/images/VPS/calc.png": 791,
	"./assets/images/VPS/centos.svg": 792,
	"./assets/images/VPS/chooseOs.svg": 793,
	"./assets/images/VPS/common-types.svg": 794,
	"./assets/images/VPS/console.svg": 795,
	"./assets/images/VPS/container.svg": 796,
	"./assets/images/VPS/dashboard.svg": 797,
	"./assets/images/VPS/ddos-c.svg": 798,
	"./assets/images/VPS/ddos-d.svg": 799,
	"./assets/images/VPS/ddos.svg": 800,
	"./assets/images/VPS/debian.svg": 801,
	"./assets/images/VPS/disaster.svg": 802,
	"./assets/images/VPS/docker.svg": 803,
	"./assets/images/VPS/everything.svg": 804,
	"./assets/images/VPS/externalServer.svg": 805,
	"./assets/images/VPS/firewall-new.svg": 806,
	"./assets/images/VPS/firewall.png": 807,
	"./assets/images/VPS/freeSupport.svg": 808,
	"./assets/images/VPS/global.svg": 809,
	"./assets/images/VPS/hq.svg": 810,
	"./assets/images/VPS/iaas_catalogue.png": 811,
	"./assets/images/VPS/ico.png": 812,
	"./assets/images/VPS/image1.svg": 813,
	"./assets/images/VPS/increase.svg": 814,
	"./assets/images/VPS/infrustructure.svg": 815,
	"./assets/images/VPS/ip.png": 816,
	"./assets/images/VPS/iranServer.svg": 758,
	"./assets/images/VPS/list-vps.svg": 817,
	"./assets/images/VPS/mikrotik.svg": 818,
	"./assets/images/VPS/mysql.svg": 819,
	"./assets/images/VPS/nStep1-m.svg": 759,
	"./assets/images/VPS/nStep1.svg": 760,
	"./assets/images/VPS/nginx.svg": 820,
	"./assets/images/VPS/nodejs.svg": 821,
	"./assets/images/VPS/not-found-mobile.svg": 822,
	"./assets/images/VPS/not-found.svg": 823,
	"./assets/images/VPS/panel.svg": 824,
	"./assets/images/VPS/pattern.png": 825,
	"./assets/images/VPS/plans.svg": 826,
	"./assets/images/VPS/plans/Maple.svg": 682,
	"./assets/images/VPS/plans/Willow.svg": 683,
	"./assets/images/VPS/plans/beech.svg": 684,
	"./assets/images/VPS/plans/cedar.svg": 685,
	"./assets/images/VPS/plans/pine.svg": 686,
	"./assets/images/VPS/plans/poplar.svg": 687,
	"./assets/images/VPS/platform.png": 827,
	"./assets/images/VPS/platform2.png": 828,
	"./assets/images/VPS/python.svg": 829,
	"./assets/images/VPS/resource.svg": 830,
	"./assets/images/VPS/service-mgs.svg": 831,
	"./assets/images/VPS/service-vpc.svg": 832,
	"./assets/images/VPS/service-vps.svg": 833,
	"./assets/images/VPS/service.svg": 834,
	"./assets/images/VPS/siem.svg": 835,
	"./assets/images/VPS/sla.svg": 836,
	"./assets/images/VPS/startup.svg": 837,
	"./assets/images/VPS/support.svg": 838,
	"./assets/images/VPS/test.svg": 839,
	"./assets/images/VPS/top-ways.svg": 840,
	"./assets/images/VPS/traffic-vps.svg": 841,
	"./assets/images/VPS/ubuntu18.svg": 842,
	"./assets/images/VPS/ubuntu22.svg": 843,
	"./assets/images/VPS/uptime.svg": 844,
	"./assets/images/VPS/video.png": 845,
	"./assets/images/VPS/vps-header.svg": 752,
	"./assets/images/VPS/vps-hourly.svg": 757,
	"./assets/images/VPS/vps-platform.png": 846,
	"./assets/images/VPS/vps1.png": 847,
	"./assets/images/VPS/vps10.png": 848,
	"./assets/images/VPS/vps2.png": 849,
	"./assets/images/VPS/vps3.png": 850,
	"./assets/images/VPS/vps4.png": 851,
	"./assets/images/VPS/vps5.png": 852,
	"./assets/images/VPS/vps6.png": 853,
	"./assets/images/VPS/vps7.png": 854,
	"./assets/images/VPS/vps8.png": 855,
	"./assets/images/VPS/vps9.png": 856,
	"./assets/images/VPS/vps_figure.png": 857,
	"./assets/images/VPS/vps_icon.png": 858,
	"./assets/images/VPS/vps_picture2.png": 859,
	"./assets/images/VPS/vpspackage.png": 860,
	"./assets/images/VPS/waf-c.svg": 861,
	"./assets/images/VPS/waf-d.svg": 862,
	"./assets/images/VPS/waf-icon-active.svg": 863,
	"./assets/images/VPS/waf-icon.svg": 864,
	"./assets/images/VPS/waf-vps.svg": 865,
	"./assets/images/VPS/waf.svg": 866,
	"./assets/images/VPS/windows.svg": 867,
	"./assets/images/VPS/wordpress.svg": 868,
	"./assets/images/Xicon.svg": 401,
	"./assets/images/banners/123.svg": 2027,
	"./assets/images/banners/Banner-Traffic-Campaign.png": 2028,
	"./assets/images/banners/Banner.jpg": 2029,
	"./assets/images/banners/Banner2.jpg": 2030,
	"./assets/images/banners/Cloud-Database.webp": 2031,
	"./assets/images/banners/Help.webp": 2032,
	"./assets/images/banners/Network-Banner.webp": 2033,
	"./assets/images/banners/Post-1.webp": 2034,
	"./assets/images/banners/Post-2.webp": 2035,
	"./assets/images/banners/Post-3.webp": 2036,
	"./assets/images/banners/SLA.webp": 2037,
	"./assets/images/banners/VPSvsVDS.webp": 2038,
	"./assets/images/banners/banner6.svg": 2039,
	"./assets/images/banners/nowruz-1403-banner.png": 2040,
	"./assets/images/banners/server-response-time.webp": 2041,
	"./assets/images/banners/vpc-service.svg": 2042,
	"./assets/images/banners/yalda-report.png": 2043,
	"./assets/images/cdn/CDN-Header.svg": 1215,
	"./assets/images/cdn/Feature-1.svg": 1297,
	"./assets/images/cdn/Feature-2.svg": 1298,
	"./assets/images/cdn/Feature-3.svg": 1299,
	"./assets/images/cdn/Feature-4.svg": 1300,
	"./assets/images/cdn/Feature-5.svg": 1301,
	"./assets/images/cdn/Feature-6.svg": 1302,
	"./assets/images/cdn/Feature-7.svg": 1303,
	"./assets/images/cdn/Feature-8.svg": 1304,
	"./assets/images/cdn/IranMap.svg": 1137,
	"./assets/images/cdn/Malwares_Attackers.svg": 1305,
	"./assets/images/cdn/access.svg": 1306,
	"./assets/images/cdn/atactks.svg": 1307,
	"./assets/images/cdn/cms.svg": 1308,
	"./assets/images/cdn/company-c.svg": 1309,
	"./assets/images/cdn/company.svg": 1310,
	"./assets/images/cdn/customer.svg": 1311,
	"./assets/images/cdn/ddos-c.svg": 1312,
	"./assets/images/cdn/ddos-d.svg": 1313,
	"./assets/images/cdn/ddos.svg": 1314,
	"./assets/images/cdn/ddosAtacks.svg": 1315,
	"./assets/images/cdn/domain-c.svg": 1316,
	"./assets/images/cdn/domain-d.svg": 1317,
	"./assets/images/cdn/domain.svg": 1318,
	"./assets/images/cdn/domainss.svg": 1319,
	"./assets/images/cdn/earth.svg": 1145,
	"./assets/images/cdn/geography.svg": 1320,
	"./assets/images/cdn/no.svg": 871,
	"./assets/images/cdn/price.svg": 1321,
	"./assets/images/cdn/report-c.svg": 1322,
	"./assets/images/cdn/report-d.svg": 1323,
	"./assets/images/cdn/report.svg": 1324,
	"./assets/images/cdn/scrubbing.svg": 1149,
	"./assets/images/cdn/seo.svg": 1325,
	"./assets/images/cdn/speed.svg": 1326,
	"./assets/images/cdn/ssl.svg": 1327,
	"./assets/images/cdn/startup-c.svg": 1328,
	"./assets/images/cdn/startup.svg": 1329,
	"./assets/images/cdn/store-c.svg": 1330,
	"./assets/images/cdn/store.svg": 1331,
	"./assets/images/cdn/tick.svg": 1332,
	"./assets/images/cdn/uptime.svg": 1333,
	"./assets/images/cdn/waf-c.svg": 1334,
	"./assets/images/cdn/waf-d.svg": 1335,
	"./assets/images/cdn/waf.svg": 1336,
	"./assets/images/cdn/yes.svg": 872,
	"./assets/images/cdn/zarb.svg": 1337,
	"./assets/images/close.svg": 252,
	"./assets/images/cloudGuard/AutomaticProtection.svg": 2044,
	"./assets/images/cloudGuard/CreateCustomRules.svg": 2045,
	"./assets/images/cloudGuard/DDosSection.svg": 2046,
	"./assets/images/cloudGuard/PermanentAccess.svg": 2047,
	"./assets/images/cloudGuard/ReducingDistance.svg": 2048,
	"./assets/images/cloudGuard/SaveResources.svg": 2049,
	"./assets/images/cloudGuard/WebFirewall.svg": 2050,
	"./assets/images/cloudGuard/approach.svg": 2051,
	"./assets/images/cloudGuard/appsAttacks.svg": 2052,
	"./assets/images/cloudGuard/cdnService.svg": 2053,
	"./assets/images/cloudGuard/cloudGuard.svg": 2054,
	"./assets/images/cloudGuard/cloudguard_catalogue.png": 2055,
	"./assets/images/cloudGuard/company-c.svg": 2056,
	"./assets/images/cloudGuard/company.svg": 2057,
	"./assets/images/cloudGuard/ddos-c.svg": 2058,
	"./assets/images/cloudGuard/ddos-d.svg": 2059,
	"./assets/images/cloudGuard/ddos.svg": 2060,
	"./assets/images/cloudGuard/ddosProtection.svg": 2061,
	"./assets/images/cloudGuard/disasterRecovery.svg": 2062,
	"./assets/images/cloudGuard/firewall.svg": 2063,
	"./assets/images/cloudGuard/firewallSetting-c.svg": 2064,
	"./assets/images/cloudGuard/firewallSetting-d.svg": 2065,
	"./assets/images/cloudGuard/firewallSetting.svg": 2066,
	"./assets/images/cloudGuard/freeDNS.svg": 2067,
	"./assets/images/cloudGuard/iam.svg": 2068,
	"./assets/images/cloudGuard/infiniteDomain.svg": 2069,
	"./assets/images/cloudGuard/ip.svg": 2070,
	"./assets/images/cloudGuard/layer7attacks.svg": 2071,
	"./assets/images/cloudGuard/limit-c.svg": 2072,
	"./assets/images/cloudGuard/limit-d.svg": 2073,
	"./assets/images/cloudGuard/limit.svg": 2074,
	"./assets/images/cloudGuard/limitedAccess.svg": 2075,
	"./assets/images/cloudGuard/massAttacks.svg": 2076,
	"./assets/images/cloudGuard/protection.svg": 2077,
	"./assets/images/cloudGuard/protocolAttacks.svg": 2078,
	"./assets/images/cloudGuard/reduceCost.svg": 2079,
	"./assets/images/cloudGuard/region.svg": 2080,
	"./assets/images/cloudGuard/savings.svg": 2081,
	"./assets/images/cloudGuard/scrubbing.svg": 2082,
	"./assets/images/cloudGuard/security.svg": 2083,
	"./assets/images/cloudGuard/seo.svg": 2084,
	"./assets/images/cloudGuard/siem.svg": 2085,
	"./assets/images/cloudGuard/startup-c.svg": 2086,
	"./assets/images/cloudGuard/startup.svg": 2087,
	"./assets/images/cloudGuard/store-c.svg": 2088,
	"./assets/images/cloudGuard/store.svg": 2089,
	"./assets/images/cloudGuard/uptime.svg": 2090,
	"./assets/images/cloudGuard/url.svg": 2091,
	"./assets/images/cloudGuard/userInfo.svg": 2092,
	"./assets/images/cloudGuard/waf-c.svg": 2093,
	"./assets/images/cloudGuard/waf-d.svg": 2094,
	"./assets/images/cloudGuard/waf.svg": 2095,
	"./assets/images/cloudMigration/customers/bonyad-shahid.svg": 1722,
	"./assets/images/cloudMigration/customers/dataak.svg": 1723,
	"./assets/images/cloudMigration/customers/eita.svg": 1724,
	"./assets/images/cloudMigration/customers/helal-ahmar-iran.svg": 1725,
	"./assets/images/colocation/architect.svg": 1908,
	"./assets/images/colocation/firewall-new.svg": 1909,
	"./assets/images/colocation/resource.svg": 1910,
	"./assets/images/colocation/uptime.svg": 1911,
	"./assets/images/customer/day_logo(1).png": 2096,
	"./assets/images/customer/day_logo(1).svg": 2097,
	"./assets/images/customer/farrahicarpet-logo.png": 2098,
	"./assets/images/customer/farrahicarpet-logo.svg": 2099,
	"./assets/images/customer/logo-.png": 2100,
	"./assets/images/customer/logo-.svg": 2101,
	"./assets/images/customer/logo-hamrahe-aval.png": 2102,
	"./assets/images/customer/logo-hamrahe-aval.svg": 2103,
	"./assets/images/customer/logo-kermanmotor-w.png": 2104,
	"./assets/images/customer/logo-kermanmotor-w.svg": 2105,
	"./assets/images/customer/snowa_logo.png": 2106,
	"./assets/images/customer/snowa_logo.svg": 2107,
	"./assets/images/customer/uniliver(2) 1.png": 2108,
	"./assets/images/customer/uniliver(2) 1.svg": 2109,
	"./assets/images/customers/10.png": 2110,
	"./assets/images/customers/MobileViewLogo-min.png": 2111,
	"./assets/images/customers/banner/HomePage-IT.webp": 1079,
	"./assets/images/customers/banner/HomePage-agencies.webp": 1080,
	"./assets/images/customers/banner/HomePage-banks.webp": 1081,
	"./assets/images/customers/banner/HomePage-elearning.webp": 1082,
	"./assets/images/customers/banner/HomePage-foods.webp": 1083,
	"./assets/images/customers/banner/HomePage-industries.webp": 1084,
	"./assets/images/customers/banner/HomePage-innovation.webp": 1085,
	"./assets/images/customers/banner/HomePage-insurance.webp": 1086,
	"./assets/images/customers/banner/HomePage-manufacturing-firms.webp": 1087,
	"./assets/images/customers/banner/HomePage-media.webp": 1088,
	"./assets/images/customers/banner/HomePage-universities.webp": 1089,
	"./assets/images/customers/banner/Khandevane.png": 1090,
	"./assets/images/customers/banner/sunich.png": 1091,
	"./assets/images/customers/bime-day.png": 2112,
	"./assets/images/customers/eseminar.png": 2113,
	"./assets/images/customers/khandevane.png": 2114,
	"./assets/images/customers/logo/Azad.png": 885,
	"./assets/images/customers/logo/IRISA.png": 886,
	"./assets/images/customers/logo/Mapna.png": 887,
	"./assets/images/customers/logo/Samseir.png": 888,
	"./assets/images/customers/logo/day-insurance-gary.png": 889,
	"./assets/images/customers/logo/day-insurance.png": 890,
	"./assets/images/customers/logo/dey.png": 891,
	"./assets/images/customers/logo/diginext-gray.png": 892,
	"./assets/images/customers/logo/diginext.png": 893,
	"./assets/images/customers/logo/eastcool-gray.png": 894,
	"./assets/images/customers/logo/eastcool-rgb.png": 895,
	"./assets/images/customers/logo/esiminar.png": 896,
	"./assets/images/customers/logo/irisa-gray.png": 897,
	"./assets/images/customers/logo/irisa.png": 898,
	"./assets/images/customers/logo/istcoll.png": 899,
	"./assets/images/customers/logo/khandevane-gray.png": 900,
	"./assets/images/customers/logo/khandevane-rgb.png": 901,
	"./assets/images/customers/logo/khandevaneh.png": 902,
	"./assets/images/customers/logo/pars.png": 903,
	"./assets/images/customers/logo/pegah.png": 904,
	"./assets/images/customers/logo/persis-foods-gray.png": 905,
	"./assets/images/customers/logo/persis-foods-rgb.png": 906,
	"./assets/images/customers/logo/refah.png": 907,
	"./assets/images/customers/logo/shahr-financial-group-gray.png": 908,
	"./assets/images/customers/logo/shahr-financial-group.png": 909,
	"./assets/images/customers/logo/shahr.png": 910,
	"./assets/images/customers/logo/sunich-gray.png": 911,
	"./assets/images/customers/logo/sunich-rgb.png": 912,
	"./assets/images/customers/meydon.png": 2115,
	"./assets/images/customers/parskh.png": 2116,
	"./assets/images/customers/parsonline.png": 2117,
	"./assets/images/customers/refah.png": 2118,
	"./assets/images/customers/shahr.png": 2119,
	"./assets/images/customers/t1.png": 2120,
	"./assets/images/ddosProtection/1.svg": 987,
	"./assets/images/ddosProtection/2.svg": 988,
	"./assets/images/ddosProtection/3.svg": 989,
	"./assets/images/ddosProtection/CloudGuard-Service.svg": 990,
	"./assets/images/ddosProtection/DNS.svg": 991,
	"./assets/images/ddosProtection/ManagedService-Service.svg": 992,
	"./assets/images/ddosProtection/VPC-Service.svg": 993,
	"./assets/images/ddosProtection/VPS-Service.svg": 994,
	"./assets/images/ddosProtection/ddos-d.svg": 995,
	"./assets/images/ddosProtection/ddos-image.svg": 924,
	"./assets/images/ddosProtection/ddos.svg": 996,
	"./assets/images/ddosProtection/devops.svg": 997,
	"./assets/images/ddosProtection/exclusive.svg": 998,
	"./assets/images/ddosProtection/firewall-ability.1bb527e 1.svg": 999,
	"./assets/images/ddosProtection/firewall-setting.cc1ac98 1.svg": 1000,
	"./assets/images/ddosProtection/focus.svg": 1001,
	"./assets/images/ddosProtection/hardening.svg": 1002,
	"./assets/images/ddosProtection/limitation.cb39432 1.svg": 1003,
	"./assets/images/ddosProtection/monitoring.svg": 1004,
	"./assets/images/ddosProtection/technical.svg": 1005,
	"./assets/images/ddosProtection/traffic-vps.aa00c67 1.svg": 1006,
	"./assets/images/ddosProtection/waf-d.svg": 1007,
	"./assets/images/ddosProtection/waf-icon-active.svg": 1008,
	"./assets/images/ddosProtection/waf-icon.svg": 1009,
	"./assets/images/ddosProtection/waf.svg": 1010,
	"./assets/images/dedicateServer/backup.svg": 2121,
	"./assets/images/dedicateServer/buy.svg": 2122,
	"./assets/images/dedicateServer/customized.svg": 2123,
	"./assets/images/dedicateServer/dedicate-server.svg": 2124,
	"./assets/images/dedicateServer/internal-cloud.svg": 2125,
	"./assets/images/dedicateServer/internal.svg": 2126,
	"./assets/images/dedicateServer/performance.svg": 2127,
	"./assets/images/dedicateServer/resource.svg": 2128,
	"./assets/images/dedicateServer/secure.svg": 2129,
	"./assets/images/dedicateServer/web-hosting.svg": 2130,
	"./assets/images/dedicatedServer/firewall-new.svg": 1749,
	"./assets/images/dedicatedServer/image1.svg": 1750,
	"./assets/images/dedicatedServer/resource.svg": 1751,
	"./assets/images/dedicatedServer/uptime.svg": 1752,
	"./assets/images/devops/apps/Ansible.svg": 1753,
	"./assets/images/devops/apps/Apache-Mesos.svg": 1754,
	"./assets/images/devops/apps/Apache.svg": 1755,
	"./assets/images/devops/apps/Cassandra.svg": 1756,
	"./assets/images/devops/apps/Ceph.svg": 1757,
	"./assets/images/devops/apps/Chef.svg": 1758,
	"./assets/images/devops/apps/Datadog.svg": 1759,
	"./assets/images/devops/apps/Docker-Swarm.svg": 1760,
	"./assets/images/devops/apps/Elastic-Stack.svg": 1761,
	"./assets/images/devops/apps/GitLab.svg": 1762,
	"./assets/images/devops/apps/GlusterFS.svg": 1763,
	"./assets/images/devops/apps/Grafana.svg": 1764,
	"./assets/images/devops/apps/IIS.svg": 1765,
	"./assets/images/devops/apps/Jenkins.svg": 1766,
	"./assets/images/devops/apps/Kubernetes.svg": 1767,
	"./assets/images/devops/apps/Lighttpd.svg": 1768,
	"./assets/images/devops/apps/LiteSpeed.svg": 1769,
	"./assets/images/devops/apps/MariaDB.svg": 1770,
	"./assets/images/devops/apps/MinIO.svg": 1771,
	"./assets/images/devops/apps/MongoDB.svg": 1772,
	"./assets/images/devops/apps/MySQL.svg": 1773,
	"./assets/images/devops/apps/NextCloud.svg": 1774,
	"./assets/images/devops/apps/Nginx.svg": 1775,
	"./assets/images/devops/apps/OpenShift.svg": 1776,
	"./assets/images/devops/apps/PostgreSQL.svg": 1777,
	"./assets/images/devops/apps/Prometheus.svg": 1778,
	"./assets/images/devops/apps/Puppet.svg": 1779,
	"./assets/images/devops/apps/Redis.svg": 1780,
	"./assets/images/devops/apps/Splunk.svg": 1781,
	"./assets/images/devops/apps/Terraform.svg": 1782,
	"./assets/images/devops/apps/Tomcat.svg": 1783,
	"./assets/images/devops/apps/Zabbix.svg": 1784,
	"./assets/images/devops/customers/Azad-Uni.webp": 1275,
	"./assets/images/devops/customers/Bank-Sina.webp": 1276,
	"./assets/images/devops/customers/Iraninan-Poshesh.webp": 1277,
	"./assets/images/devops/customers/azad-university.svg": 1278,
	"./assets/images/devops/customers/helal-ahmar.svg": 1279,
	"./assets/images/devops/customers/helal-ahmar.webp": 1280,
	"./assets/images/devops/customers/iranian-insurance.svg": 1281,
	"./assets/images/devops/customers/sina-bank.svg": 1282,
	"./assets/images/devops/icons/Feature-3.svg": 1118,
	"./assets/images/devops/icons/Feature-6.svg": 1119,
	"./assets/images/devops/icons/agility.svg": 1120,
	"./assets/images/devops/icons/centralized.svg": 1121,
	"./assets/images/devops/icons/configuration.svg": 1122,
	"./assets/images/devops/icons/devops.svg": 1123,
	"./assets/images/devops/icons/enterprise.svg": 1124,
	"./assets/images/devops/icons/focus.svg": 1125,
	"./assets/images/devops/icons/hardening.svg": 1126,
	"./assets/images/devops/icons/hosting.svg": 1127,
	"./assets/images/devops/icons/monitor.svg": 1128,
	"./assets/images/devops/icons/monitoring.svg": 1129,
	"./assets/images/devops/icons/startupLoad.svg": 1130,
	"./assets/images/devops/icons/technical.svg": 1131,
	"./assets/images/devops/icons/test.svg": 1132,
	"./assets/images/devops/images/section-header.svg": 1144,
	"./assets/images/devops/images/storage.svg": 1338,
	"./assets/images/dns/DNS-Header.svg": 1267,
	"./assets/images/dns/Feature-1.svg": 1785,
	"./assets/images/dns/Feature-2.svg": 1786,
	"./assets/images/dns/Feature-3.svg": 1787,
	"./assets/images/dns/Feature-4.svg": 1788,
	"./assets/images/dns/anyCast.svg": 1789,
	"./assets/images/dns/dnsPanel.svg": 1790,
	"./assets/images/dns/noLimit.svg": 1791,
	"./assets/images/dns/responseDelay.svg": 1792,
	"./assets/images/dns/unlimitedDomain.svg": 1793,
	"./assets/images/dnsproxy/logos/AMD.svg": 1431,
	"./assets/images/dnsproxy/logos/CentOs.svg": 1432,
	"./assets/images/dnsproxy/logos/DockerHub.svg": 1433,
	"./assets/images/dnsproxy/logos/ElasticStack.svg": 1434,
	"./assets/images/dnsproxy/logos/FedoraProject.svg": 1435,
	"./assets/images/dnsproxy/logos/GitHub.svg": 1436,
	"./assets/images/dnsproxy/logos/GitLab.svg": 1437,
	"./assets/images/dnsproxy/logos/Golang.svg": 1438,
	"./assets/images/dnsproxy/logos/Grafana.svg": 1439,
	"./assets/images/dnsproxy/logos/Intel.svg": 1440,
	"./assets/images/dnsproxy/logos/Jenkins.svg": 1441,
	"./assets/images/dnsproxy/logos/Kubernetes.svg": 1442,
	"./assets/images/dnsproxy/logos/Microsoft.svg": 1443,
	"./assets/images/dnsproxy/logos/NVIDIADeveloper.svg": 1444,
	"./assets/images/dnsproxy/logos/Node.js.svg": 1445,
	"./assets/images/dnsproxy/logos/Oracle.svg": 1446,
	"./assets/images/dnsproxy/logos/Prometheus.svg": 1447,
	"./assets/images/dnsproxy/logos/Python.svg": 1448,
	"./assets/images/dnsproxy/logos/RedHat.svg": 1449,
	"./assets/images/dnsproxy/logos/RockyLinux.svg": 1450,
	"./assets/images/dnsproxy/logos/Splunk.svg": 1451,
	"./assets/images/dnsproxy/logos/TeamViewer.svg": 1452,
	"./assets/images/dnsproxy/logos/TensorFlow.svg": 1453,
	"./assets/images/dnsproxy/logos/Ubuntu.svg": 1454,
	"./assets/images/dnsproxy/logos/VMware.svg": 1455,
	"./assets/images/dnsproxy/logos/mongodb.svg": 1456,
	"./assets/images/dnsproxy/logos/virtualbox.svg": 1457,
	"./assets/images/enterprise-services/VPC-Main.svg": 1794,
	"./assets/images/enterprise-services/benefit.svg": 1795,
	"./assets/images/enterprise-services/header.svg": 1796,
	"./assets/images/europeVps/24.svg": 1458,
	"./assets/images/europeVps/CloudGuard-Service.svg": 1459,
	"./assets/images/europeVps/DNS.svg": 1460,
	"./assets/images/europeVps/ManagedService-Service.svg": 1461,
	"./assets/images/europeVps/VPC-Service.svg": 1462,
	"./assets/images/europeVps/backup.svg": 1463,
	"./assets/images/europeVps/chooseOs.svg": 1464,
	"./assets/images/europeVps/console.svg": 1465,
	"./assets/images/europeVps/dashboard.svg": 1466,
	"./assets/images/europeVps/ddos-d.svg": 1467,
	"./assets/images/europeVps/ddos.svg": 1468,
	"./assets/images/europeVps/disaster.svg": 1469,
	"./assets/images/europeVps/freeSupport.svg": 1470,
	"./assets/images/europeVps/global.svg": 1471,
	"./assets/images/europeVps/hq.svg": 1472,
	"./assets/images/europeVps/infrustructure.svg": 1473,
	"./assets/images/europeVps/list-vps.f735948 1.svg": 1474,
	"./assets/images/europeVps/service.svg": 1475,
	"./assets/images/europeVps/startup.svg": 1476,
	"./assets/images/europeVps/traffic-vps.aa00c67 1.svg": 1477,
	"./assets/images/europeVps/waf-d.svg": 1478,
	"./assets/images/europeVps/waf-icon-active copy.svg": 1479,
	"./assets/images/europeVps/waf-icon-active.svg": 1480,
	"./assets/images/europeVps/waf-icon.svg": 1481,
	"./assets/images/europeVps/waf-vps.fcecd73 1.svg": 1482,
	"./assets/images/europeVps/waf.svg": 1483,
	"./assets/images/events/sari-event-mobile.webp": 1797,
	"./assets/images/events/sari-event.webp": 1798,
	"./assets/images/footer.png": 443,
	"./assets/images/footer/anjoman.svg": 444,
	"./assets/images/footer/daneshbonyan.svg": 445,
	"./assets/images/footer/enamad.svg": 446,
	"./assets/images/footer/fab.svg": 447,
	"./assets/images/footer/instagram.svg": 448,
	"./assets/images/footer/linkedin.svg": 449,
	"./assets/images/footer/location.svg": 450,
	"./assets/images/footer/nezamsenfi.svg": 451,
	"./assets/images/footer/occc.svg": 452,
	"./assets/images/footer/phone.svg": 453,
	"./assets/images/footer/riasatjomhoori.svg": 454,
	"./assets/images/footer/telegram.svg": 455,
	"./assets/images/footer/twitter.svg": 456,
	"./assets/images/footer/youtube.svg": 457,
	"./assets/images/form.svg": 402,
	"./assets/images/header-cropped.svg": 2131,
	"./assets/images/header/vpc-icon.webp": 1580,
	"./assets/images/home/Content distribution-c.svg": 2132,
	"./assets/images/home/Managedservices-c.svg": 2133,
	"./assets/images/home/Platform-c.svg": 2134,
	"./assets/images/home/Server-c.svg": 2135,
	"./assets/images/home/TrafficCampaign.svg": 2136,
	"./assets/images/home/contentdistribution.svg": 2137,
	"./assets/images/home/contentdistribution_d.svg": 2138,
	"./assets/images/home/data center-c.svg": 2139,
	"./assets/images/home/general_catalogue.png": 2140,
	"./assets/images/home/live.svg": 2141,
	"./assets/images/home/manageServices.svg": 2142,
	"./assets/images/home/manageServices_d.svg": 2143,
	"./assets/images/home/nowruz-1403-logo.svg": 2144,
	"./assets/images/home/nowruz.png": 2145,
	"./assets/images/home/paas.svg": 2146,
	"./assets/images/home/paas_d.svg": 2147,
	"./assets/images/home/security-c.svg": 2148,
	"./assets/images/home/security.svg": 2149,
	"./assets/images/home/security_d.svg": 2150,
	"./assets/images/home/shop.svg": 2151,
	"./assets/images/home/vpc.svg": 2152,
	"./assets/images/home/vpc_d.svg": 2153,
	"./assets/images/home/vps.svg": 2154,
	"./assets/images/home/vps_d.svg": 2155,
	"./assets/images/home/yalda-m.svg": 2156,
	"./assets/images/home/yalda.png": 2157,
	"./assets/images/hourlyVps/1minute.svg": 1484,
	"./assets/images/hourlyVps/24.svg": 1485,
	"./assets/images/hourlyVps/CloudGuard-Service.svg": 1486,
	"./assets/images/hourlyVps/DNS.svg": 1487,
	"./assets/images/hourlyVps/ManagedService-Service.svg": 1488,
	"./assets/images/hourlyVps/VPC-Service.svg": 1489,
	"./assets/images/hourlyVps/chooseOs.svg": 1490,
	"./assets/images/hourlyVps/console.svg": 1491,
	"./assets/images/hourlyVps/dashboard.svg": 1492,
	"./assets/images/hourlyVps/ddos-d.svg": 1493,
	"./assets/images/hourlyVps/ddos.svg": 1494,
	"./assets/images/hourlyVps/disaster.svg": 1495,
	"./assets/images/hourlyVps/firewall-new.svg": 1496,
	"./assets/images/hourlyVps/freeSupport.svg": 1497,
	"./assets/images/hourlyVps/global.svg": 1498,
	"./assets/images/hourlyVps/hq.svg": 1499,
	"./assets/images/hourlyVps/increase.svg": 1500,
	"./assets/images/hourlyVps/infrustructure.svg": 1501,
	"./assets/images/hourlyVps/list-vps.f735948 1.svg": 1502,
	"./assets/images/hourlyVps/sla.svg": 1503,
	"./assets/images/hourlyVps/startup.svg": 1504,
	"./assets/images/hourlyVps/support.svg": 1505,
	"./assets/images/hourlyVps/test.svg": 1506,
	"./assets/images/hourlyVps/traffic-vps.aa00c67 1.svg": 1507,
	"./assets/images/hourlyVps/uptime.svg": 1508,
	"./assets/images/hourlyVps/virtualOrganization.svg": 1509,
	"./assets/images/hourlyVps/waf-d.svg": 1510,
	"./assets/images/hourlyVps/waf-icon-active.svg": 1511,
	"./assets/images/hourlyVps/waf-icon.svg": 1512,
	"./assets/images/hourlyVps/waf-vps.fcecd73 1.svg": 1513,
	"./assets/images/hourlyVps/waf.svg": 1514,
	"./assets/images/icons/1.png": 689,
	"./assets/images/icons/2.png": 690,
	"./assets/images/icons/3.png": 691,
	"./assets/images/icons/4.png": 692,
	"./assets/images/icons/5.png": 693,
	"./assets/images/icons/5.svg": 694,
	"./assets/images/icons/6.png": 695,
	"./assets/images/icons/7.png": 696,
	"./assets/images/icons/CloudGuard-Service.svg": 697,
	"./assets/images/icons/DNS.svg": 698,
	"./assets/images/icons/GoDown.png": 699,
	"./assets/images/icons/GoDown.svg": 700,
	"./assets/images/icons/GoTop.png": 701,
	"./assets/images/icons/GoTop.svg": 702,
	"./assets/images/icons/Group 420.png": 703,
	"./assets/images/icons/Group 420.svg": 704,
	"./assets/images/icons/Group 78.png": 705,
	"./assets/images/icons/Group 78.svg": 706,
	"./assets/images/icons/Group.png": 707,
	"./assets/images/icons/Insta.png": 708,
	"./assets/images/icons/ManagedService-Service.svg": 709,
	"./assets/images/icons/VPC-Service.svg": 710,
	"./assets/images/icons/VPS-Service.svg": 711,
	"./assets/images/icons/anjoman_s.png": 712,
	"./assets/images/icons/anjoman_s.svg": 713,
	"./assets/images/icons/bar.svg": 714,
	"./assets/images/icons/cloud-dns.svg": 715,
	"./assets/images/icons/contact.png": 716,
	"./assets/images/icons/contact.svg": 688,
	"./assets/images/icons/daneshbonyan.png": 717,
	"./assets/images/icons/daneshbonyan.svg": 718,
	"./assets/images/icons/ddos.svg": 719,
	"./assets/images/icons/discount.png": 720,
	"./assets/images/icons/discount.svg": 721,
	"./assets/images/icons/enamad-logo.png": 722,
	"./assets/images/icons/enamad-logo.svg": 723,
	"./assets/images/icons/facebook.png": 724,
	"./assets/images/icons/facebook.svg": 725,
	"./assets/images/icons/github.png": 726,
	"./assets/images/icons/github.svg": 727,
	"./assets/images/icons/insta.svg": 728,
	"./assets/images/icons/instagram.png": 729,
	"./assets/images/icons/instagram.svg": 730,
	"./assets/images/icons/linked.svg": 731,
	"./assets/images/icons/linkedin.png": 732,
	"./assets/images/icons/linkedin.svg": 733,
	"./assets/images/icons/new/xaas-instagram.png": 734,
	"./assets/images/icons/new/xaas-linkedin.png": 735,
	"./assets/images/icons/new/xaas-telegram.png": 736,
	"./assets/images/icons/new/xaas-twitter.png": 737,
	"./assets/images/icons/new/xaas-youtube.png": 738,
	"./assets/images/icons/nezam-senfi.png": 739,
	"./assets/images/icons/nezam-senfi.svg": 740,
	"./assets/images/icons/quote.png": 679,
	"./assets/images/icons/showMore.svg": 674,
	"./assets/images/icons/tweet.svg": 741,
	"./assets/images/icons/tweter.png": 742,
	"./assets/images/icons/twitter.png": 743,
	"./assets/images/icons/twitter.svg": 744,
	"./assets/images/icons/vps_icon2.png": 745,
	"./assets/images/icons/xaas-fab.png": 746,
	"./assets/images/icons/xaas-fab.svg": 747,
	"./assets/images/icons/xaas-occc.png": 748,
	"./assets/images/icons/xaas-occc.svg": 749,
	"./assets/images/icons/xaas-riasat-jomhoori.png": 750,
	"./assets/images/icons/xaas-riasat-jomhoori.svg": 751,
	"./assets/images/img1.png": 1799,
	"./assets/images/img2.png": 2158,
	"./assets/images/isolatedCloud/CloudGuard-Service.svg": 925,
	"./assets/images/isolatedCloud/Feature-1.svg": 926,
	"./assets/images/isolatedCloud/Feature-2.svg": 927,
	"./assets/images/isolatedCloud/Feature-3.svg": 928,
	"./assets/images/isolatedCloud/Feature-4.svg": 929,
	"./assets/images/isolatedCloud/Feature-5.svg": 930,
	"./assets/images/isolatedCloud/Feature-6.svg": 931,
	"./assets/images/isolatedCloud/Feature-7.svg": 932,
	"./assets/images/isolatedCloud/Feature-8.svg": 933,
	"./assets/images/isolatedCloud/ManagedService-Service.svg": 934,
	"./assets/images/isolatedCloud/VPC-Service.svg": 935,
	"./assets/images/isolatedCloud/VPS-Service.svg": 936,
	"./assets/images/isolatedCloud/advancedSecurity.svg": 937,
	"./assets/images/isolatedCloud/backup.svg": 938,
	"./assets/images/isolatedCloud/disaster.svg": 939,
	"./assets/images/isolatedCloud/easyBuy.svg": 940,
	"./assets/images/isolatedCloud/easyUse.svg": 941,
	"./assets/images/isolatedCloud/hunezarat.svg": 922,
	"./assets/images/isolatedCloud/liveMigration.svg": 942,
	"./assets/images/isolatedCloud/reliability.svg": 943,
	"./assets/images/isolatedCloud/service.svg": 944,
	"./assets/images/isolatedCloud/startup.svg": 945,
	"./assets/images/isolatedCloud/test.svg": 946,
	"./assets/images/isolatedCloud/virtualOrganization.svg": 947,
	"./assets/images/landing/1045479.svg": 2159,
	"./assets/images/landing/2906274.svg": 2160,
	"./assets/images/landing/860238.svg": 2161,
	"./assets/images/landing/860239.svg": 2162,
	"./assets/images/landing/Group 12.svg": 2163,
	"./assets/images/landing/Group 13.svg": 2164,
	"./assets/images/landing/Group 14.svg": 2165,
	"./assets/images/landing/Group 15.svg": 2166,
	"./assets/images/landing/Group 16.webp": 2167,
	"./assets/images/landing/Group 17.svg": 2168,
	"./assets/images/landing/Group.svg": 2169,
	"./assets/images/landing/Xaas.svg": 2170,
	"./assets/images/landing/abr.svg": 2171,
	"./assets/images/landing/avatar.svg": 2172,
	"./assets/images/landing/background.png": 2173,
	"./assets/images/landing/button.svg": 2174,
	"./assets/images/landing/chamedoon.png": 2175,
	"./assets/images/landing/cloud.svg": 2176,
	"./assets/images/landing/data-analysis.svg": 2177,
	"./assets/images/landing/landing.jpg": 2178,
	"./assets/images/landing/project-analysis.svg": 2179,
	"./assets/images/landing/shield.svg": 2180,
	"./assets/images/landing/small-screen-arrow.svg": 2181,
	"./assets/images/landing/web-security.svg": 2182,
	"./assets/images/linuxVps/1minute.svg": 1581,
	"./assets/images/linuxVps/24.svg": 1582,
	"./assets/images/linuxVps/CloudGuard-Service.svg": 1583,
	"./assets/images/linuxVps/DNS.svg": 1584,
	"./assets/images/linuxVps/ManagedService-Service.svg": 1585,
	"./assets/images/linuxVps/VPC-Service.svg": 1586,
	"./assets/images/linuxVps/chooseOs.svg": 1587,
	"./assets/images/linuxVps/console.svg": 1588,
	"./assets/images/linuxVps/dashboard.svg": 1589,
	"./assets/images/linuxVps/ddos-d.svg": 1590,
	"./assets/images/linuxVps/ddos.svg": 1591,
	"./assets/images/linuxVps/firewall-new.svg": 1592,
	"./assets/images/linuxVps/freeSupport.svg": 1593,
	"./assets/images/linuxVps/global.svg": 1594,
	"./assets/images/linuxVps/hq.svg": 1595,
	"./assets/images/linuxVps/increase.svg": 1596,
	"./assets/images/linuxVps/infrustructure.svg": 1597,
	"./assets/images/linuxVps/list-vps.f735948 1.svg": 1598,
	"./assets/images/linuxVps/sla.svg": 1599,
	"./assets/images/linuxVps/support.svg": 1600,
	"./assets/images/linuxVps/traffic-vps.aa00c67 1.svg": 1601,
	"./assets/images/linuxVps/uptime.svg": 1602,
	"./assets/images/linuxVps/waf-d.svg": 1603,
	"./assets/images/linuxVps/waf-icon-active.svg": 1604,
	"./assets/images/linuxVps/waf-icon.svg": 1605,
	"./assets/images/linuxVps/waf-vps.fcecd73 1.svg": 1606,
	"./assets/images/linuxVps/waf.svg": 1607,
	"./assets/images/logo-w.svg": 2183,
	"./assets/images/logo.svg": 1608,
	"./assets/images/menu-icons/addons.svg": 404,
	"./assets/images/menu-icons/blog.svg": 405,
	"./assets/images/menu-icons/calc.svg": 406,
	"./assets/images/menu-icons/cdn.svg": 407,
	"./assets/images/menu-icons/cdn24.svg": 408,
	"./assets/images/menu-icons/cloud-network.svg": 409,
	"./assets/images/menu-icons/combination-cloud.svg": 410,
	"./assets/images/menu-icons/company-size.svg": 411,
	"./assets/images/menu-icons/coprate.svg": 412,
	"./assets/images/menu-icons/ddos.svg": 413,
	"./assets/images/menu-icons/digital-tahavol.svg": 414,
	"./assets/images/menu-icons/faq.svg": 415,
	"./assets/images/menu-icons/free.svg": 416,
	"./assets/images/menu-icons/how-to-start.svg": 417,
	"./assets/images/menu-icons/in-xaas.svg": 418,
	"./assets/images/menu-icons/industry.svg": 419,
	"./assets/images/menu-icons/infra.svg": 420,
	"./assets/images/menu-icons/left15.svg": 421,
	"./assets/images/menu-icons/left7.svg": 422,
	"./assets/images/menu-icons/main3.svg": 423,
	"./assets/images/menu-icons/manage.svg": 424,
	"./assets/images/menu-icons/manage24.svg": 425,
	"./assets/images/menu-icons/migrate.svg": 426,
	"./assets/images/menu-icons/organ-docs.svg": 427,
	"./assets/images/menu-icons/organ-security.svg": 428,
	"./assets/images/menu-icons/organ-solutions.svg": 429,
	"./assets/images/menu-icons/organization.svg": 430,
	"./assets/images/menu-icons/paas.svg": 431,
	"./assets/images/menu-icons/prices.svg": 432,
	"./assets/images/menu-icons/private-cloud.svg": 433,
	"./assets/images/menu-icons/security.svg": 434,
	"./assets/images/menu-icons/service-help.svg": 435,
	"./assets/images/menu-icons/sla.svg": 436,
	"./assets/images/menu-icons/special.svg": 437,
	"./assets/images/menu-icons/storage.svg": 438,
	"./assets/images/menu-icons/tech-services-for-organs.svg": 439,
	"./assets/images/menu-icons/vpc.svg": 440,
	"./assets/images/menu-icons/vps.svg": 441,
	"./assets/images/new_customers/HiMart.png": 2184,
	"./assets/images/new_customers/amirkabir.png": 2185,
	"./assets/images/new_customers/azad.png": 2186,
	"./assets/images/new_customers/bankrefah.png": 2187,
	"./assets/images/new_customers/bankshahr.png": 2188,
	"./assets/images/new_customers/barkat.png": 2189,
	"./assets/images/new_customers/bidbarg.png": 2190,
	"./assets/images/new_customers/bime-dey.png": 2191,
	"./assets/images/new_customers/digikala.png": 2192,
	"./assets/images/new_customers/eastcool.png": 2193,
	"./assets/images/new_customers/elmosanat.png": 2194,
	"./assets/images/new_customers/freezone.png": 2195,
	"./assets/images/new_customers/irisaco.png": 2196,
	"./assets/images/new_customers/jameazad.png": 2197,
	"./assets/images/new_customers/javid.png": 2198,
	"./assets/images/new_customers/khandevane.png": 2199,
	"./assets/images/new_customers/madiran.png": 2200,
	"./assets/images/new_customers/mahran.png": 2201,
	"./assets/images/new_customers/mashal.png": 2202,
	"./assets/images/new_customers/meydon.png": 2203,
	"./assets/images/new_customers/mofid.png": 2204,
	"./assets/images/new_customers/netbarg.png": 2205,
	"./assets/images/new_customers/parskhazar.png": 2206,
	"./assets/images/new_customers/parsonline.png": 2207,
	"./assets/images/new_customers/pegah.png": 2208,
	"./assets/images/new_customers/pejoheshgah.png": 2209,
	"./assets/images/new_customers/samseir.png": 2210,
	"./assets/images/new_customers/tanzim.png": 2211,
	"./assets/images/organizationalSolution/24.svg": 1339,
	"./assets/images/organizationalSolution/CDN-Header.svg": 923,
	"./assets/images/organizationalSolution/CloudGuard-Service.svg": 1340,
	"./assets/images/organizationalSolution/DNS.svg": 1341,
	"./assets/images/organizationalSolution/HA.svg": 1342,
	"./assets/images/organizationalSolution/Isolation.svg": 1343,
	"./assets/images/organizationalSolution/ManagedService-Service.svg": 1344,
	"./assets/images/organizationalSolution/VPC-Main.svg": 1283,
	"./assets/images/organizationalSolution/VPC-Service.svg": 1345,
	"./assets/images/organizationalSolution/architect.svg": 1346,
	"./assets/images/organizationalSolution/backup.svg": 1347,
	"./assets/images/organizationalSolution/blancing.svg": 1348,
	"./assets/images/organizationalSolution/chooseOs.svg": 1349,
	"./assets/images/organizationalSolution/container.svg": 1350,
	"./assets/images/organizationalSolution/dashboard.svg": 1351,
	"./assets/images/organizationalSolution/ddos-image.svg": 1284,
	"./assets/images/organizationalSolution/devops.svg": 1352,
	"./assets/images/organizationalSolution/freeSupport.svg": 1353,
	"./assets/images/organizationalSolution/global.svg": 1354,
	"./assets/images/organizationalSolution/header.svg": 1355,
	"./assets/images/organizationalSolution/improve.svg": 1356,
	"./assets/images/organizationalSolution/increase.svg": 1357,
	"./assets/images/organizationalSolution/kuber.svg": 1358,
	"./assets/images/organizationalSolution/migration.svg": 1359,
	"./assets/images/organizationalSolution/monitoring.svg": 1360,
	"./assets/images/organizationalSolution/openstack.svg": 1361,
	"./assets/images/organizationalSolution/panel.svg": 1362,
	"./assets/images/organizationalSolution/plans.svg": 1363,
	"./assets/images/organizationalSolution/resource.svg": 1364,
	"./assets/images/organizationalSolution/service.svg": 1365,
	"./assets/images/organizationalSolution/sla.svg": 1366,
	"./assets/images/organizationalSolution/snapshot.svg": 1367,
	"./assets/images/organizationalSolution/support.svg": 1368,
	"./assets/images/paas/1.png": 1800,
	"./assets/images/paas/1.svg": 1801,
	"./assets/images/paas/10.svg": 1802,
	"./assets/images/paas/2.png": 1803,
	"./assets/images/paas/2.svg": 1804,
	"./assets/images/paas/3.png": 1805,
	"./assets/images/paas/3.svg": 1806,
	"./assets/images/paas/4.png": 1807,
	"./assets/images/paas/4.svg": 1808,
	"./assets/images/paas/5.svg": 1609,
	"./assets/images/paas/6.svg": 1610,
	"./assets/images/paas/7.svg": 1611,
	"./assets/images/paas/8.svg": 1809,
	"./assets/images/paas/9.svg": 1810,
	"./assets/images/paas/api.svg": 1811,
	"./assets/images/paas/dashboard.svg": 1812,
	"./assets/images/paas/esteghrar.svg": 1813,
	"./assets/images/paas/event.svg": 1814,
	"./assets/images/paas/logo.svg": 1612,
	"./assets/images/paas/monitoring.svg": 1815,
	"./assets/images/paas/scale.svg": 1816,
	"./assets/images/paas/store.svg": 1817,
	"./assets/images/paas/support.svg": 1818,
	"./assets/images/paas/tozie.svg": 1819,
	"./assets/images/pam/auth2.svg": 1515,
	"./assets/images/pam/browser.svg": 1516,
	"./assets/images/pam/control.svg": 1517,
	"./assets/images/pam/device.svg": 1518,
	"./assets/images/pam/health.svg": 1519,
	"./assets/images/pam/impersonate.svg": 1520,
	"./assets/images/pam/leak.svg": 1521,
	"./assets/images/pam/limit-access.svg": 1522,
	"./assets/images/pam/log.svg": 1523,
	"./assets/images/pam/manage-acc.svg": 1524,
	"./assets/images/pam/manage-security.svg": 1525,
	"./assets/images/pam/manage-user.svg": 1526,
	"./assets/images/pam/manage.svg": 1527,
	"./assets/images/pam/mfa.svg": 1528,
	"./assets/images/pam/otp.svg": 1529,
	"./assets/images/pam/pam.svg": 1530,
	"./assets/images/pam/prevent.svg": 1531,
	"./assets/images/pam/protocol.svg": 1532,
	"./assets/images/pam/record.svg": 1533,
	"./assets/images/pam/reports.svg": 1534,
	"./assets/images/pam/users.svg": 1535,
	"./assets/images/pam/web.svg": 1536,
	"./assets/images/pomegrante.svg": 2212,
	"./assets/images/rebranding/catalogue/managed-services-catalogue.webp": 2213,
	"./assets/images/rebranding/catalogue/solutions-catalogue.webp": 1613,
	"./assets/images/rebranding/contact/account.svg": 2214,
	"./assets/images/rebranding/contact/contract.svg": 2215,
	"./assets/images/rebranding/contact/products.svg": 2216,
	"./assets/images/rebranding/contact/support.svg": 2217,
	"./assets/images/rebranding/content/cdn.webp": 1220,
	"./assets/images/rebranding/content/colocation.webp": 1221,
	"./assets/images/rebranding/content/ddos.webp": 1222,
	"./assets/images/rebranding/content/dedicated-server.webp": 1223,
	"./assets/images/rebranding/content/dns.webp": 1224,
	"./assets/images/rebranding/content/firewall.webp": 1225,
	"./assets/images/rebranding/content/graphics-server.webp": 1226,
	"./assets/images/rebranding/content/local-storage.webp": 1227,
	"./assets/images/rebranding/content/object-storage.webp": 1228,
	"./assets/images/rebranding/content/vpc.webp": 1229,
	"./assets/images/rebranding/content/vps.webp": 1230,
	"./assets/images/rebranding/content/waf.webp": 1231,
	"./assets/images/rebranding/customerLogos/1.webp": 1369,
	"./assets/images/rebranding/customerLogos/10.webp": 1370,
	"./assets/images/rebranding/customerLogos/11.webp": 1371,
	"./assets/images/rebranding/customerLogos/12.webp": 1372,
	"./assets/images/rebranding/customerLogos/13.webp": 1373,
	"./assets/images/rebranding/customerLogos/14.webp": 1374,
	"./assets/images/rebranding/customerLogos/15.webp": 1375,
	"./assets/images/rebranding/customerLogos/16.webp": 1376,
	"./assets/images/rebranding/customerLogos/17.webp": 1377,
	"./assets/images/rebranding/customerLogos/18.webp": 1378,
	"./assets/images/rebranding/customerLogos/19.webp": 1379,
	"./assets/images/rebranding/customerLogos/2.webp": 1380,
	"./assets/images/rebranding/customerLogos/20.webp": 1381,
	"./assets/images/rebranding/customerLogos/21.webp": 1382,
	"./assets/images/rebranding/customerLogos/22.webp": 1383,
	"./assets/images/rebranding/customerLogos/23.webp": 1384,
	"./assets/images/rebranding/customerLogos/24.webp": 1385,
	"./assets/images/rebranding/customerLogos/25.webp": 1386,
	"./assets/images/rebranding/customerLogos/26.webp": 1387,
	"./assets/images/rebranding/customerLogos/27.webp": 1388,
	"./assets/images/rebranding/customerLogos/28.webp": 1389,
	"./assets/images/rebranding/customerLogos/29.webp": 1390,
	"./assets/images/rebranding/customerLogos/3.webp": 1391,
	"./assets/images/rebranding/customerLogos/30.webp": 1392,
	"./assets/images/rebranding/customerLogos/31.webp": 1393,
	"./assets/images/rebranding/customerLogos/32.webp": 1394,
	"./assets/images/rebranding/customerLogos/33.webp": 1395,
	"./assets/images/rebranding/customerLogos/34.webp": 1396,
	"./assets/images/rebranding/customerLogos/35.webp": 1397,
	"./assets/images/rebranding/customerLogos/36.webp": 1398,
	"./assets/images/rebranding/customerLogos/37.webp": 1399,
	"./assets/images/rebranding/customerLogos/38.webp": 1400,
	"./assets/images/rebranding/customerLogos/39.webp": 1401,
	"./assets/images/rebranding/customerLogos/4.webp": 1402,
	"./assets/images/rebranding/customerLogos/40.webp": 1403,
	"./assets/images/rebranding/customerLogos/5.webp": 1404,
	"./assets/images/rebranding/customerLogos/6.webp": 1405,
	"./assets/images/rebranding/customerLogos/7.webp": 1406,
	"./assets/images/rebranding/customerLogos/8.webp": 1407,
	"./assets/images/rebranding/customerLogos/9.webp": 1408,
	"./assets/images/rebranding/customers/content/e-seminar.webp": 1409,
	"./assets/images/rebranding/customers/content/helal-ahmar.webp": 1410,
	"./assets/images/rebranding/customers/content/ikco.webp": 1411,
	"./assets/images/rebranding/customers/content/mapna.webp": 1412,
	"./assets/images/rebranding/customers/content/milli-1.webp": 1413,
	"./assets/images/rebranding/customers/content/milli.webp": 1414,
	"./assets/images/rebranding/customers/content/solico.webp": 1415,
	"./assets/images/rebranding/customers/e-seminar.png": 1614,
	"./assets/images/rebranding/customers/helal-ahmar.png": 1615,
	"./assets/images/rebranding/customers/ikco.png": 1616,
	"./assets/images/rebranding/customers/mapna.png": 1617,
	"./assets/images/rebranding/customers/milli-gold.png": 1618,
	"./assets/images/rebranding/customers/solico.png": 1619,
	"./assets/images/rebranding/heroBackground.webp": 1620,
	"./assets/images/rebranding/logo/logo-abalon-en.png": 442,
	"./assets/images/rebranding/logo/logo-abalon-fa.png": 403,
	"./assets/images/rebranding/logo/logo-blue.svg": 2218,
	"./assets/images/rebranding/logo/logo-dark.svg": 2219,
	"./assets/images/rebranding/logo/logo-en-botton-blue.svg": 2220,
	"./assets/images/rebranding/logo/logo-en-botton-dark.svg": 2221,
	"./assets/images/rebranding/logo/logo-en-botton-gradiant.svg": 2222,
	"./assets/images/rebranding/logo/logo-en-botton-white.svg": 2223,
	"./assets/images/rebranding/logo/logo-en-left-blue.svg": 2224,
	"./assets/images/rebranding/logo/logo-en-left-dark.svg": 2225,
	"./assets/images/rebranding/logo/logo-en-left-gradiant.svg": 2226,
	"./assets/images/rebranding/logo/logo-en-left-white.svg": 2227,
	"./assets/images/rebranding/logo/logo-fa-botton-blue.svg": 2228,
	"./assets/images/rebranding/logo/logo-fa-botton-dark.svg": 2229,
	"./assets/images/rebranding/logo/logo-fa-botton-gradiant.svg": 2230,
	"./assets/images/rebranding/logo/logo-fa-botton-white.svg": 2231,
	"./assets/images/rebranding/logo/logo-fa-left-blue.svg": 2232,
	"./assets/images/rebranding/logo/logo-fa-left-dark.svg": 2233,
	"./assets/images/rebranding/logo/logo-fa-left-gradiant.svg": 2234,
	"./assets/images/rebranding/logo/logo-fa-left-white.svg": 2235,
	"./assets/images/rebranding/logo/logo-gradiant.svg": 2236,
	"./assets/images/rebranding/logo/logo-white.svg": 2237,
	"./assets/images/rebranding/pages/1.b820ea4 1.svg": 952,
	"./assets/images/rebranding/pages/3.32dda95 1.svg": 953,
	"./assets/images/rebranding/pages/Api.701b548 2.svg": 963,
	"./assets/images/rebranding/pages/CloudCanvas.82fd9ce 1.svg": 964,
	"./assets/images/rebranding/pages/Firewall.398439d 1.svg": 965,
	"./assets/images/rebranding/pages/LoadBalancers.4b40924 1.svg": 966,
	"./assets/images/rebranding/pages/Logo.svg": 961,
	"./assets/images/rebranding/pages/NetworkTopology.3e287eb 1.svg": 967,
	"./assets/images/rebranding/pages/Step1.73148bc.svg": 954,
	"./assets/images/rebranding/pages/VPC-Main.b1c5b7f.svg": 870,
	"./assets/images/rebranding/pages/VirtualMachins.217b5d7 1.svg": 968,
	"./assets/images/rebranding/pages/Volumes.d769ca6 1.svg": 969,
	"./assets/images/rebranding/pages/WAE.svg": 970,
	"./assets/images/rebranding/pages/abalon-logo.svg": 971,
	"./assets/images/rebranding/pages/cloud-platforms.png": 955,
	"./assets/images/rebranding/pages/ddos-c.7eebc2f 1.svg": 972,
	"./assets/images/rebranding/pages/dnsPanel.af7f507 1.svg": 956,
	"./assets/images/rebranding/pages/domain-c.409b389.svg": 973,
	"./assets/images/rebranding/pages/firewall-ability.1bb527e 1.svg": 974,
	"./assets/images/rebranding/pages/firewall-ability.1bb527e 2.svg": 975,
	"./assets/images/rebranding/pages/firewall-setting.cc1ac98 1.svg": 976,
	"./assets/images/rebranding/pages/header.1b96d2f 1.svg": 960,
	"./assets/images/rebranding/pages/kuber.png": 957,
	"./assets/images/rebranding/pages/limitation.cb39432 1.svg": 977,
	"./assets/images/rebranding/pages/list-vps.f735948 1.svg": 978,
	"./assets/images/rebranding/pages/map.9a4bec5 1.svg": 958,
	"./assets/images/rebranding/pages/not-found-mobile.7b6fab4.svg": 672,
	"./assets/images/rebranding/pages/not-found.4ba4a5c 1.svg": 673,
	"./assets/images/rebranding/pages/report-c.11b26e7 1.svg": 979,
	"./assets/images/rebranding/pages/traffic-vps.aa00c67 1.svg": 980,
	"./assets/images/rebranding/pages/waf-c.6f5be55 1.svg": 981,
	"./assets/images/rebranding/pages/waf-vps.fcecd73 1.svg": 982,
	"./assets/images/rebranding/products/card-background-1.webp": 1621,
	"./assets/images/rebranding/products/card-background-2.webp": 1622,
	"./assets/images/rebranding/products/card-background.webp": 1157,
	"./assets/images/rebranding/products2/1.svg": 1623,
	"./assets/images/rebranding/products2/2.svg": 1624,
	"./assets/images/rebranding/products2/3.svg": 1625,
	"./assets/images/rebranding/products2/4.svg": 1626,
	"./assets/images/rebranding/products2/5.svg": 1627,
	"./assets/images/rebranding/products2/6.svg": 1628,
	"./assets/images/rebranding/products2/backup/1.svg": 1629,
	"./assets/images/rebranding/products2/backup/2.svg": 1630,
	"./assets/images/rebranding/products2/backup/3.svg": 1631,
	"./assets/images/rebranding/products2/backup/4.svg": 1632,
	"./assets/images/rebranding/products2/backup/5.svg": 1633,
	"./assets/images/rebranding/products2/backup/6.svg": 1634,
	"./assets/images/rebranding/products2/backup/primary.svg": 1635,
	"./assets/images/rebranding/products2/devops/1.svg": 1636,
	"./assets/images/rebranding/products2/devops/2.svg": 1637,
	"./assets/images/rebranding/products2/devops/3.svg": 1638,
	"./assets/images/rebranding/products2/devops/4.svg": 1639,
	"./assets/images/rebranding/products2/devops/5.svg": 1640,
	"./assets/images/rebranding/products2/devops/6.svg": 1641,
	"./assets/images/rebranding/products2/devops/primary.svg": 1642,
	"./assets/images/rebranding/products2/kuber/1.svg": 1643,
	"./assets/images/rebranding/products2/kuber/2.svg": 1644,
	"./assets/images/rebranding/products2/kuber/3.svg": 1645,
	"./assets/images/rebranding/products2/kuber/4.svg": 1646,
	"./assets/images/rebranding/products2/kuber/5.svg": 1647,
	"./assets/images/rebranding/products2/kuber/6.svg": 1648,
	"./assets/images/rebranding/products2/migration/1.svg": 1649,
	"./assets/images/rebranding/products2/migration/2.svg": 1650,
	"./assets/images/rebranding/products2/migration/3.svg": 1651,
	"./assets/images/rebranding/products2/migration/4.svg": 1652,
	"./assets/images/rebranding/products2/migration/5.svg": 1653,
	"./assets/images/rebranding/products2/migration/6.svg": 1654,
	"./assets/images/rebranding/products2/migration/primary.svg": 1655,
	"./assets/images/rebranding/products2/privateCloud/1.svg": 1656,
	"./assets/images/rebranding/products2/privateCloud/2.svg": 1657,
	"./assets/images/rebranding/products2/privateCloud/3.svg": 1658,
	"./assets/images/rebranding/products2/privateCloud/4.svg": 1659,
	"./assets/images/rebranding/products2/privateCloud/5.svg": 1660,
	"./assets/images/rebranding/products2/privateCloud/6.svg": 1661,
	"./assets/images/rebranding/products2/privateCloud/primary.svg": 1662,
	"./assets/images/rebranding/products2/productsPrimaryBackground.png": 1663,
	"./assets/images/rebranding/products2/secureCloud/1.svg": 1664,
	"./assets/images/rebranding/products2/secureCloud/2.svg": 1665,
	"./assets/images/rebranding/products2/secureCloud/3.svg": 1666,
	"./assets/images/rebranding/products2/secureCloud/4.svg": 1667,
	"./assets/images/rebranding/products2/secureCloud/5.svg": 1668,
	"./assets/images/rebranding/products2/secureCloud/6.svg": 1669,
	"./assets/images/rebranding/products2/secureCloud/primary.svg": 1670,
	"./assets/images/rebranding/products2/security/1.svg": 1671,
	"./assets/images/rebranding/products2/security/2.svg": 1672,
	"./assets/images/rebranding/products2/security/3.svg": 1673,
	"./assets/images/rebranding/products2/security/4.svg": 1674,
	"./assets/images/rebranding/products2/security/5.svg": 1675,
	"./assets/images/rebranding/products2/security/6.svg": 1676,
	"./assets/images/rebranding/products2/security/primary.svg": 1677,
	"./assets/images/rebranding/services/services-image.webp": 1678,
	"./assets/images/rebranding/statisticsBackground.webp": 1679,
	"./assets/images/sectionTwo/section1.svg": 2238,
	"./assets/images/security/1.svg": 1820,
	"./assets/images/security/10.svg": 1821,
	"./assets/images/security/11.svg": 1822,
	"./assets/images/security/12.svg": 1823,
	"./assets/images/security/13.svg": 1824,
	"./assets/images/security/14.svg": 1825,
	"./assets/images/security/15.svg": 1826,
	"./assets/images/security/16.svg": 1827,
	"./assets/images/security/17.svg": 1828,
	"./assets/images/security/18.svg": 1829,
	"./assets/images/security/2.svg": 1830,
	"./assets/images/security/3.svg": 1831,
	"./assets/images/security/4.svg": 1832,
	"./assets/images/security/5.svg": 1833,
	"./assets/images/security/6.svg": 1834,
	"./assets/images/security/7.svg": 1835,
	"./assets/images/security/8.svg": 1836,
	"./assets/images/security/9.svg": 1837,
	"./assets/images/security/WAF.svg": 1838,
	"./assets/images/security/ddos-ability.svg": 1839,
	"./assets/images/security/ddos-image.svg": 1680,
	"./assets/images/security/ddos.svg": 1840,
	"./assets/images/security/dlp.svg": 1841,
	"./assets/images/security/dmz.svg": 1842,
	"./assets/images/security/dr.svg": 1843,
	"./assets/images/security/firewall-ability.svg": 1844,
	"./assets/images/security/firewall-image.svg": 1537,
	"./assets/images/security/firewall-setting.svg": 1845,
	"./assets/images/security/firewall-web.svg": 1846,
	"./assets/images/security/firewall.svg": 1847,
	"./assets/images/security/header-image.svg": 1158,
	"./assets/images/security/hunezarat.svg": 1093,
	"./assets/images/security/iam.svg": 1848,
	"./assets/images/security/items-1.svg": 1849,
	"./assets/images/security/limitation.png": 1850,
	"./assets/images/security/limitation.svg": 1851,
	"./assets/images/security/private.svg": 1852,
	"./assets/images/security/sandbox.svg": 1853,
	"./assets/images/security/scan.svg": 1854,
	"./assets/images/security/sec2-mobile.svg": 1855,
	"./assets/images/security/sec2.svg": 1856,
	"./assets/images/security/siem.svg": 1857,
	"./assets/images/security/virus.svg": 1858,
	"./assets/images/security/waf-banner.svg": 962,
	"./assets/images/service_icons/1.jpg": 2239,
	"./assets/images/service_icons/10.jpg": 2240,
	"./assets/images/service_icons/11.jpg": 2241,
	"./assets/images/service_icons/12.jpg": 2242,
	"./assets/images/service_icons/13.jpg": 2243,
	"./assets/images/service_icons/14.jpg": 2244,
	"./assets/images/service_icons/15.jpg": 2245,
	"./assets/images/service_icons/16.jpg": 2246,
	"./assets/images/service_icons/17.jpg": 2247,
	"./assets/images/service_icons/18.jpg": 2248,
	"./assets/images/service_icons/19.jpg": 2249,
	"./assets/images/service_icons/2.jpg": 2250,
	"./assets/images/service_icons/20.jpg": 2251,
	"./assets/images/service_icons/21.jpg": 2252,
	"./assets/images/service_icons/22.jpg": 2253,
	"./assets/images/service_icons/23.jpg": 2254,
	"./assets/images/service_icons/24.jpg": 2255,
	"./assets/images/service_icons/25.jpg": 2256,
	"./assets/images/service_icons/26.jpg": 2257,
	"./assets/images/service_icons/27.jpg": 2258,
	"./assets/images/service_icons/28.jpg": 2259,
	"./assets/images/service_icons/3.jpg": 2260,
	"./assets/images/service_icons/4.jpg": 2261,
	"./assets/images/service_icons/5.jpg": 2262,
	"./assets/images/service_icons/6.jpg": 2263,
	"./assets/images/service_icons/7.jpg": 2264,
	"./assets/images/service_icons/8.jpg": 2265,
	"./assets/images/service_icons/9.jpg": 2266,
	"./assets/images/siem/Acunetix.svg": 1538,
	"./assets/images/siem/Arista-Networks.svg": 1539,
	"./assets/images/siem/Barracuda-NextGen.svg": 1540,
	"./assets/images/siem/Barracuda.svg": 1541,
	"./assets/images/siem/Bitdefender-GravityZone.svg": 1542,
	"./assets/images/siem/Cisco-ASA.svg": 1543,
	"./assets/images/siem/CrowdStrike-Falcon.svg": 1544,
	"./assets/images/siem/CyberArk.svg": 1545,
	"./assets/images/siem/F5-Network.svg": 1546,
	"./assets/images/siem/Fortinet.svg": 1547,
	"./assets/images/siem/Juniper-SRX.svg": 1548,
	"./assets/images/siem/Kaspersky-Endpoint-Security.svg": 1549,
	"./assets/images/siem/Manageengine-IPFIX.svg": 1550,
	"./assets/images/siem/McAfee-MVISION-EDR.svg": 1551,
	"./assets/images/siem/Metasploit.svg": 1552,
	"./assets/images/siem/MikroTik-RouterOS.svg": 1553,
	"./assets/images/siem/Nmap.svg": 1554,
	"./assets/images/siem/Paessler-NetFlow.svg": 1555,
	"./assets/images/siem/Palo-Alto-NGFW.svg": 1556,
	"./assets/images/siem/Qualys.svg": 1557,
	"./assets/images/siem/Rapid7-Nexpose.svg": 1558,
	"./assets/images/siem/SonicWall-TZ.svg": 1559,
	"./assets/images/siem/Sophos-Intercept- X.svg": 1560,
	"./assets/images/siem/Tenable-Nessus.svg": 1561,
	"./assets/images/siem/Trend-Micro-Apex-One.svg": 1562,
	"./assets/images/siem/Ubiquiti-UniFi.svg": 1563,
	"./assets/images/siem/Wireshark.svg": 1564,
	"./assets/images/siem/palo-alto-networks.svg": 1565,
	"./assets/images/slider.jpg": 2267,
	"./assets/images/solutions/digital-tahavol.svg": 1859,
	"./assets/images/solutions/organization-cloud.svg": 1860,
	"./assets/images/solutions/organization-security.svg": 1861,
	"./assets/images/solutions/organization-solutions.svg": 1862,
	"./assets/images/solutions/orgranization-services.svg": 1863,
	"./assets/images/svg/Banner.jpg": 2268,
	"./assets/images/svg/Group409.svg": 2269,
	"./assets/images/svg/Rectangle1.png": 2270,
	"./assets/images/svg/Rectangle2.png": 2271,
	"./assets/images/svg/Rectangle3.png": 2272,
	"./assets/images/svg/Rectangle4.png": 2273,
	"./assets/images/svg/benefit.svg": 875,
	"./assets/images/svg/cloud.svg": 874,
	"./assets/images/svg/not-found.png": 2274,
	"./assets/images/svg/plan.svg": 2275,
	"./assets/images/svg/slider-bg.svg": 1092,
	"./assets/images/videos/vpc-video.mp4": 2276,
	"./assets/images/videos/vps-video.mp4": 2277,
	"./assets/images/virtualServer/Feature-1.svg": 1232,
	"./assets/images/virtualServer/Feature-2.svg": 1233,
	"./assets/images/virtualServer/Feature-3.svg": 1234,
	"./assets/images/virtualServer/Feature-4.svg": 1235,
	"./assets/images/virtualServer/Feature-5.svg": 1236,
	"./assets/images/virtualServer/Feature-6.svg": 1237,
	"./assets/images/virtualServer/Feature-7.svg": 1238,
	"./assets/images/virtualServer/Feature-8.svg": 1239,
	"./assets/images/virtualServer/Step1-m.svg": 1216,
	"./assets/images/virtualServer/Step1.svg": 1217,
	"./assets/images/virtualServer/Step2-m.svg": 1150,
	"./assets/images/virtualServer/Step2.svg": 1151,
	"./assets/images/virtualServer/Step3.svg": 1152,
	"./assets/images/virtualServer/advancedSecurity.svg": 1240,
	"./assets/images/virtualServer/backup.svg": 1241,
	"./assets/images/virtualServer/easyBuy.svg": 1242,
	"./assets/images/virtualServer/easyUse.svg": 1243,
	"./assets/images/virtualServer/externalServer.svg": 1244,
	"./assets/images/virtualServer/focus.svg": 1245,
	"./assets/images/virtualServer/hosting.svg": 1246,
	"./assets/images/virtualServer/hourlyServer.svg": 1218,
	"./assets/images/virtualServer/iranServer.svg": 1247,
	"./assets/images/virtualServer/liveMigration.svg": 1248,
	"./assets/images/virtualServer/noLimit.svg": 1249,
	"./assets/images/virtualServer/reliability.svg": 1250,
	"./assets/images/virtualServer/siem.svg": 1251,
	"./assets/images/virtualServer/startupLoad.svg": 1252,
	"./assets/images/virtualServer/test.svg": 1253,
	"./assets/images/virtualServer/virtual-server.svg": 1014,
	"./assets/images/virtualServer/virtualDesktop.svg": 1254,
	"./assets/images/virtualServer/virtualOrganization.svg": 1255,
	"./assets/images/vps-icons/ManagedService-head.png": 2278,
	"./assets/images/vps-icons/ManagedService.png": 2279,
	"./assets/images/vps-icons/P1.png": 2280,
	"./assets/images/vps-icons/P2.png": 2281,
	"./assets/images/vps-icons/P3.png": 2282,
	"./assets/images/vps-icons/P4.png": 2283,
	"./assets/images/vps-icons/P5.png": 2284,
	"./assets/images/vps-icons/download.png": 2285,
	"./assets/images/vps-icons/file.png": 2286,
	"./assets/images/vps-icons/private-cloud.png": 2287,
	"./assets/images/vps-icons/private-icon.png": 2288,
	"./assets/images/vps-icons/vps.png": 2289,
	"./assets/images/vps-icons/vps_back.png": 2290,
	"./assets/images/vps-icons/vps_icon.png": 2291,
	"./assets/images/vps-icons/vps_icon2.png": 2292,
	"./assets/images/vps-icons/vps_icon_fix.png": 2293,
	"./assets/images/vps-icons/vps_icon_pic.png": 2294,
	"./assets/images/vps-icons/vps_ip.png": 2295,
	"./assets/images/vps-icons/vps_pattern.png": 2296,
	"./assets/images/vps-icons/vps_pattern2.png": 2297,
	"./assets/images/vps-icons/vps_picture.png": 2298,
	"./assets/images/vps-icons/vps_picture2.png": 2299,
	"./assets/images/vps-icons/vps_picture3.png": 2300,
	"./assets/images/vps-icons/vps_security.png": 2301,
	"./assets/images/vps-icons/vps_video.png": 2302,
	"./assets/images/vps-icons/vpss.png": 2303,
	"./assets/images/vps-icons/xaas-cloud.png": 2304,
	"./assets/images/windowsVps/24.svg": 1864,
	"./assets/images/windowsVps/Feature-1.svg": 1865,
	"./assets/images/windowsVps/Feature-3.svg": 1866,
	"./assets/images/windowsVps/benefit.svg": 1681,
	"./assets/images/windowsVps/centralized.svg": 1867,
	"./assets/images/windowsVps/chooseOs copy.svg": 1868,
	"./assets/images/windowsVps/chooseOs.svg": 1869,
	"./assets/images/windowsVps/configuration.svg": 1870,
	"./assets/images/windowsVps/console.svg": 1871,
	"./assets/images/windowsVps/dashboard.svg": 1872,
	"./assets/images/windowsVps/ddos-d.svg": 1873,
	"./assets/images/windowsVps/ddos.svg": 1874,
	"./assets/images/windowsVps/dr.svg": 1875,
	"./assets/images/windowsVps/freeSupport.svg": 1876,
	"./assets/images/windowsVps/global.svg": 1877,
	"./assets/images/windowsVps/hq.svg": 1878,
	"./assets/images/windowsVps/increase.svg": 1879,
	"./assets/images/windowsVps/infrustructure.svg": 1880,
	"./assets/images/windowsVps/list-vps.f735948 1.svg": 1881,
	"./assets/images/windowsVps/resource.svg": 1882,
	"./assets/images/windowsVps/sla.svg": 1883,
	"./assets/images/windowsVps/support.svg": 1884,
	"./assets/images/windowsVps/traffic-vps.aa00c67 1.svg": 1885,
	"./assets/images/windowsVps/waf-d.svg": 1886,
	"./assets/images/windowsVps/waf-icon-active.svg": 1887,
	"./assets/images/windowsVps/waf-icon.svg": 1888,
	"./assets/images/windowsVps/waf-vps.fcecd73 1.svg": 1889,
	"./assets/images/windowsVps/waf.svg": 1890,
	"./assets/images/xaas-gift.png": 2305,
	"./assets/images/xaas-icons/Hybrid Cloud.svg": 1891,
	"./assets/images/xaas-icons/Private Cloud.svg": 1892,
	"./assets/images/xaas-icons/Public Cloud.svg": 1893,
	"./assets/images/xaas-icons/datacenter.png": 2306,
	"./assets/images/xaas-icons/security.png": 2307,
	"./assets/images/xaas-icons/support.png": 2308,
	"./assets/images/xaas-icons/xaas-payment.png": 2309,
	"./assets/images/xaas-icons/xaas-period.png": 2310,
	"./assets/images/xaas-icons/xaas-scale.png": 2311,
	"./assets/images/xaas-icons/xaas-security.png": 2312,
	"./assets/images/xaas-icons/xaas-support.png": 2313,
	"./assets/text-styles.scss": 2473,
	"./assets/variables.scss": 2475
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2346;